<template>
  <div class="game-container" ref="gameContainer">
    <!-- 主游戏内容区域 -->
    <div class="game-main" ref="gameMainRef" :class="{'game-main--expanded': isExpanded }"
      @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd"
      @wheel="handleWheel">
      <GameSettingsDiceTabsWrapper class="settings-wrapper">
        <GameSettingsButtonFast v-model="gameStore.redpacket.fast" />
        <GameSettingsButtonRule v-model="oVisible.isOpenRule" name="niuNiuGame" />
        <GameSettingsButtonVocie v-model="settingStore.inhouseGames.sound.on"
          v-model:voice-model-value="settingStore.inhouseGames.sound.music" :saveAfterChange="true">
        </GameSettingsButtonVocie>
      </GameSettingsDiceTabsWrapper>

      <ClientOnly>
        <IndoorHeader ref="indoorHeaderRef" :lastRoundResult="lastRoundResult" :onLineCount="onLineCount"
          :bankerCards="bankerCards" @open-trend-chart="isOpenTrendChart = true"
          @open-history="isOpenHistoryList = true" @open-player-list="isOpenPlayerList = true"
          @open-select-room="isOpenSelectRoom = true" :gameStatus="gameStatus" :countdownValue="countdownValue" />
      </ClientOnly>

      <!-- 游戏内容区域 -->
      <ClientOnly>
        <HallCover ref="hallCoverRef" :scale-ratio="scaleRatio" :lastRoundResult="lastRoundResult" :sectorCards="sectorCards"
          @area-clicked="handleAreaClick" :tables="tables" :areaTotalValues="areaTotalValues"
          :allPlayersTotalValues="allPlayersTotalValues" :winningSectors="winningSectors"
          />
      </ClientOnly>
    </div>

    <!-- 底部控制面板 -->
    <ClientOnly>
      <HallFooter :rtp="rtp" :is-entrance="false">
        <template #area>
          <!-- 筹码价值显示 -->
          <div class="chip-value-header">
            <!-- 撤销按钮 -->
            <div class="cancel-btn" v-if="!isCancelButtonDisabled"
              @click="!isCancelButtonDisabled ? cancelBetting() : undefined">
              <IconSvgUse use="icon-cancel" class="w-[20px] h-[20px] mr-[5.5px]" />
              <span>{{ $t('niuniu.cancel') }}</span>
            </div>
            <div v-else class="cancel-btn" :disabled="false"
              @click="!isCancelButtonDisabled ? cancelBetting() : undefined">
              <IconSvgUse use="icon-cancel" class="w-[20px] h-[20px] mr-[5.5px]" />
              <span>{{ $t('niuniu.cancel') }}</span>
            </div>

            <div class="chip-value-display">
              <span class="chip-value-label">{{ $t('niuniu.chipValue') }}</span>
              <CurrentCoin class="!w-[16px] !h-[16px]" :name="pickedCurrency" />
              <span class="chip-value-amount">{{ chipValue }}</span>
            </div>
          </div>

          <!-- 筹码选择与操作区域 -->
          <div class="flex justify-between flex-nowrap items-start gap-[10px] w-full chip-container">
            <!-- 筹码选择器折叠面板 -->
            <q-expansion-item dense expand-icon="expand_more" class="chip-expansion-wrapper flex-1 min-w-0"
              :style="{ opacity: gameStatus === 'BETTING' ? 1 : 0.6 }" v-model="isExpanded"
              @before-show="handleBeforeExpand" @after-show="handleAfterExpand">
              <template v-slot:header>
                <div class="chip-expansion-header-content">
                  <!-- 第一行显示前5个常用筹码 -->
                  <div class="chip-selector-header">
                    <div v-for="(chip, index) in betChips.slice(0, 5)" :key="index" class="chip-item"
                      :class="{ 'chip-active': chip.active, 'chip-disabled': !isChipAvailable(chip.value) }"
                      @click.stop="(gameStatus === 'BETTING' && isChipAvailable(chip.value)) ? handleChipSelect(chip.name) : undefined"
                      :style="{ cursor: (gameStatus === 'BETTING' && isChipAvailable(chip.value)) ? 'pointer' : 'not-allowed', opacity: (gameStatus === 'BETTING' && isChipAvailable(chip.value)) ? 1 : 0.3 }">
                      <img :src="getChipPng(chip.value)" class="chip-png" :alt="`chip-${chip.value}`" />
                    </div>
                  </div>
                </div>
              </template>

              <!-- 展开后显示后4个高额筹码 -->
              <div class="chip-selector-expanded" :class="{ 'disabled': gameStatus !== 'BETTING' }">
                <div v-for="(chip, index) in betChips.slice(5)" :key="index + 5" class="chip-item"
                  :class="{ 'chip-active': chip.active, 'chip-disabled': !isChipAvailable(chip.value) }"
                  @click="(gameStatus === 'BETTING' && isChipAvailable(chip.value)) ? handleChipSelect(chip.name) : undefined"
                  :style="{ cursor: (gameStatus === 'BETTING' && isChipAvailable(chip.value)) ? 'pointer' : 'not-allowed', opacity: (gameStatus === 'BETTING' && isChipAvailable(chip.value)) ? 1 : 0.3 }">
                  <img :src="getChipPng(chip.value)" class="chip-png" :alt="`chip-${chip.value}`" />
                </div>
              </div>
            </q-expansion-item>

            <!-- 续发按钮 -->
            <ButtonThe3DButton class="repeat-btn" color="red" :disabled="isRepeatButtonDisabled"
              :style="{ opacity: isRepeatButtonDisabled ? 0.6 : 1 }"
              @click="!isRepeatButtonDisabled ? handleContinueGame() : undefined">
              {{ isRepeatingBets ? $t('niuniu.ReDealing') : $t('niuniu.ReDeal') }}
            </ButtonThe3DButton>
          </div>
        </template>
      </HallFooter>
    </ClientOnly>

  </div>
  <!-- 下注状态 - 添加过渡动画防止抖动 -->
  <Transition name="fade">
    <playStatus v-show="showStatus" :gameStatus="gameStatus" />
  </Transition>

  <!-- 通吃通赔显示 -->
  <!-- 通赔 -->
  <Transition name="take-lose-all">
    <div
      v-if="gameStatus === 'SHOW_RESULT' && winningSectors !== null && winningSectors.length === 4 && showTakeLoseAllResult"
      class="result-display-container">
      <div class="result-container">
        <img :src="bgFogRed" class="bg-fog" alt="">
        <img :src="tpImg" class="result-image h-[63px] result-image-red" :alt="$t('niuniu.loseAll')">
      </div>
    </div>
  </Transition>

  <!-- 通吃 -->
  <Transition name="take-lose-all">
    <div
      v-if="gameStatus === 'SHOW_RESULT' && winningSectors !== null && winningSectors.length === 0 && showTakeLoseAllResult"
      class="result-display-container">
      <div class="result-container">
        <img :src="bgFogGreen" class="bg-fog" alt="">
        <img :src="tcImg" class="result-image h-[74px] result-image-green" :alt="$t('niuniu.takeAll')">
      </div>
    </div>
  </Transition>

  <!-- 非下注阶段提示 - 点击下注区域时显示 -->
  <Transition name="slide-fade">
    <div v-if="showNotBettingTip" class="show-result-tip-container">
      <div class="show-result-tip">
        <div class="flex items-center">
          <IconSvgUse use="icon-information-r" class="w-[20px] h-[20px] mr-[5.5px] tip-icon" />
          <span class="tip-text">{{ $t('niuniu.notBetTime') }}</span>
        </div>
        <IconSvgUse use="icon-close" class="w-[20px] h-[20px] close-icon" @click="handleCloseNotBettingTip" />
      </div>
    </div>
  </Transition>

  <!-- 撤销下注提示 您已成功撤销，每局只能撤销一次 -->
  <Transition name="slide-fade">
    <div v-if="cancelBettingTip" class="show-result-tip-container">
      <div class="show-result-tip">
        <div class="flex items-center">
          <IconSvgUse use="icon-cancel" class="w-[20px] h-[20px] mr-[5.5px]" />
          <span class="tip-text">{{ $t('niuniu.cancelBetTips') }}</span>
        </div>
        <IconSvgUse use="icon-close" class="w-[20px] h-[20px] close-icon" @click="cancelBettingTip = false" />
      </div>
    </div>
  </Transition>

  <!-- 选择房间 -->
  <SelectRoom v-model="isOpenSelectRoom" />
  <!-- 玩家列表 -->
  <PlayerList v-model="isOpenPlayerList" :onLineCount="onLineCount" :playerList="playerListData"
    :loading="playerListLoading" />
  <TrendChart ref="trendChartRef" v-model="isOpenTrendChart" :hallName="route?.query?.name?.toString() || 'trial'" />
  <!-- ↓ 历史"列表" 窗口 -->
  <HistoryList v-model="isOpenHistoryList"></HistoryList>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { useRouter, useRoute, onBeforeRouteLeave } from 'vue-router';
import { useUserStore } from '~/stores/user';
import { toCloseLoading } from '@/layouts/gameCoat/ts/gameCoat';
import { useNiuNiu, type NiuniuJoinParams, type NiuniuGameState, type NiuniuRoundHistoryParams } from '~/socket/game/niuniu';
import {
  fnGoToEntrance,
} from '../ts/niuniuCommon'
// 余额不足提示弹窗
const showNoticeDialog = useNoticeDialog();

import { getCardsDetailFromIds } from '../ts/cardConstants'
import {
  RESULT_TIMING,
  ALL_AREAS,
  reorderCardsWithTenMultiple as _reorderCardsWithTenMultiple,
  processAllSectorCards as _processAllSectorCards,
  getAllHandTypeInfo as _getAllHandTypeInfo,
  getCardSelector,
  displayAllHandTypes as _displayAllHandTypes,
  parseCardIds,
} from '../ts/roundResultHelpers'

// 音乐
import GameGBM from '@/assets/mp3/game_general_bgm.mp3';
import musicLose from '@/assets/mp3/redPacket/lose.mp3';
import musicWin from '@/assets/mp3/redPacket/win.mp3';
import musicSending from '@/assets/mp3/redPacket/sending.mp3';
import musicCollecting from '@/assets/mp3/redPacket/collecting.mp3';
import musicStartBetting from '../mp3/startBetting.mp3';

// 游戏音效（牛型播报、通吃通赔等）
import { createGameAudio, type GameAudioInstance } from '../ts/gameAudio';

// 通吃通赔图片
import bgFogGreen from '../img/indoor/bgFog-green.webp'
import bgFogRed from '../img/indoor/bgFog-red.webp'

import tcCn from '../img/indoor/tc_CN.png'
import tcEn from '../img/indoor/tc_EN.webp'
import tpCn from '../img/indoor/tp_CN.png'
import tpEn from '../img/indoor/tp_EN.png'

import IndoorHeader from '../_components/IndoorHeader.vue';
import HallCover from '../_components/HallCover.vue';
import HallFooter from '../_components/HallFooter.vue'
import playStatus from '../_components/playStatus.vue';

// 弹窗组件
import SelectRoom from '../_components/SelectRoom.vue';
import PlayerList from '../_components/PlayerList.vue';
import TrendChart from '../_components/TrendChart.vue';
import HistoryList from '../_components/historyList.vue';

import useGlobalStore from '@/stores/global';
const oGlobalStore = useGlobalStore();

import { useJoinStateStore } from '@/stores/cansino/joinState';
const joinStateStore = useJoinStateStore();

import useSettingsStore from '~/stores/settings';
const settingStore = useSettingsStore();
const gameStore = storeToRefs(settingStore).game;
const pickedCurrency = computed(() => settingStore.$state.pickedCurrency)

const {
  EMIT_NIUNIU_JOIN,
  EMIT_NIUNIU_BET,
  ON_NIUNIU_BET,
  ON_NIUNIU_STATE,
  ON_NIUNIU_RESULT,
  EMIT_NIUNIU_USER_LIST,
  EMIT_NIUNIU_EXIT,
  EMIT_NIUNIU_CANCEL,
  ON_NIUNIU_CANCEL,
  EMIT_NIUNIU_ROUND_HISTORY
} = useNiuNiu()

const { t: $tFn, locale } = useNuxtApp().$i18n;

// 元素可见性管理中心 
const oVisible = reactive({
  isOpenRule: false,
  historyList: true, // 历史窗口 
  resultVisible: false, // 游戏结果 
  phase02: false, // 游戏结果窗口内部元素  
  hallList: !!0,
  playerList: !!0,
});

// 音乐列表
const oMusicLib = {
  bg: {
    src: GameGBM,
    loop: true,
    isBGM: true, // true-false 表示音量取自 globalVolume, globalSoundEffects
  },
  win: { src: musicWin, },
  lose: { src: musicLose, },
  sending: { src: musicSending, },
  collecting: { src: musicCollecting, }, // 这顶似乎作用不大，
  startBetting: { src: musicStartBetting, }, // 开始下注音效
};

const oMusic = (
  import.meta.client
    ? new MusicControler(oMusicLib as any)
    : null
);

// 🎵 游戏音效管理器（牛型播报、通吃通赔、开始/停止下注等）
let gameAudio: GameAudioInstance | null = null;
if (import.meta.client) {
  gameAudio = createGameAudio(locale.value);
  // 监听语言变化，切换音效语言
  watch(locale, (newLocale) => {
    gameAudio?.setLocale(newLocale);
  });
}

const userStore = useUserStore();
// 使用 computed 确保始终获取最新的用户ID
const userId = computed(() => userStore.$state.id || 0);
const currentCurrency = ref('')

// 🎯 性能优化：缓存区域映射对象，避免重复创建
const AREA_MAPPING = Object.freeze({
  'tian': 'tian',
  'di': 'di',
  'xuan': 'xuan',
  'huang': 'huang',
  'banker': 'banker'
} as const);

// 🎯 性能优化：统一的DOM清理函数
const clearDOMChips = () => {
  try {
    // 批量收集需要删除的元素
    const chipsToRemove = [
      ...document.querySelectorAll('.permanent-chip-container'),
      ...document.querySelectorAll('.other-player-permanent-chip'),
      ...document.querySelectorAll('.other-player-chip-container'),
      ...document.querySelectorAll('.flying-chip'),
      ...document.querySelectorAll('.result-chip'),  // ✨ 清理分发后留下的筹码
      ...document.querySelectorAll('.settlement-flying-chip')  // 🎰 清理结算动画筹码
    ];

    // 一次性删除所有元素（性能更好）
    chipsToRemove.forEach(chip => chip.remove());

  } catch (error) {
    console.error('[DOM清理] 清理失败:', error);
  }
};

// 🎯 性能优化：追踪历史下注动画的定时器
const historyBetTimers = ref<number[]>([]);

// 清理所有历史下注定时器
const clearHistoryBetTimers = () => {
  historyBetTimers.value.forEach(timer => clearTimeout(timer));
  historyBetTimers.value = [];
};

const isOpenSelectRoom = ref(false)
const isOpenPlayerList = ref(false)
const isOpenTrendChart = ref(false)
const isOpenHistoryList = ref(false)

const playerListData = ref([]) //玩家列表
const onLineCount = ref(0) //在线人数
const playerListLoading = ref(false)

// 保存上一轮的下注记录，用于续发功能
const lastRoundBets = ref<BetRecord[]>([])
const isRepeatingBets = ref(false) // 是否正在执行续发
const hasRepeatedThisRound = ref(false) // 本轮是否已经续发过
const hasCancelledThisRound = ref(false) // 本轮是否已经撤销过下注
const lastRoundResult = ref({})//上局开奖结果

const route = useRoute()
const router = useRouter()

// 通吃通赔图片 - 根据语言选择（复用已有的 locale）
const tcImg = computed(() => locale.value === 'cn' ? tcCn : tcEn)
const tpImg = computed(() => locale.value === 'cn' ? tpCn : tpEn)

// 监听玩家列表模态框打开状态来获取数据
watch(isOpenPlayerList, async (newValue) => {
  if (newValue) {
    fetchPlayerList()
  }
})

// 监听房间切换，重置玩家列表数据
watch(
  () => route?.query?.name,
  (newName, oldName) => {
    // 只在房间名真正改变时重置（避免初始化时触发）
    if (newName !== oldName && oldName !== undefined) {
      // 重置玩家列表相关数据
      playerListData.value = [];
      onLineCount.value = 0;
      playerListLoading.value = false;
      // 如果玩家列表窗口是打开的，关闭它
      if (isOpenPlayerList.value) {
        isOpenPlayerList.value = false;
      }
    }
  }
);

// ↓ ws 重连时关闭遮罩 
watch(
  () => oGlobalStore.wsConnection,
  (bNew, bOld) => {
    toCloseLoading();
    if (!bNew) return;
    fnJoinTheHall(); // 加入房间，同时查询配置信息等  
  },
);

// 玩家数据列表
const fetchPlayerList = () => {
  playerListLoading.value = true

  const params = {
    hallName: route?.query?.name as string || 'trial'
  }
  EMIT_NIUNIU_USER_LIST(params, (res) => {
    // 无论成功失败都重置loading状态
    playerListLoading.value = false
    if (!res || res?.['error']) {
      showNegativeNotify(res?.['error']);
      return;
    }
    onLineCount.value = res?.onlineNum
    if (!res['userSummary']) {
      return
    }

    playerListData.value = res.userSummary
  })
}

// Import composables for animations
import { loadGSAP, collectCards, dealCardsWithData, flipCardsAnimation, stopAllCardAnimations, findTenMultipleCards, isPageVisible, markRealtimeResultProcessed, clearCardRefs } from '../ts/cardAnimation';
import { createVisibilityHandler, getVisibilitySessionId } from '../ts/visibilityHandler';
import { getNiuTypeInfo } from '../ts/gameTps';
import type { BetRecord, Player } from '../ts/bettingAnimation';
import bettingAnimation, { areaTotalValues, allPlayersTotalValues, activeBets, validateBet, startChipFlyAnimation, stopAllAnimations, startOtherPlayerBettingAnimation, createOtherPlayerPermanentChip, splitAmountToChips, getChipIcon, batchCreateChipsSync, batchBettingAnimationSimultaneous, batchCurrentPlayerBettingAnimation } from '../ts/bettingAnimation';
// 🎯 新的筹码流动动画系统（从下注区域直接飞到目标位置）
import { cleanupFlyingChips } from '../ts/chipFlowAnimation';
// 🎰 开奖后筹码结算动画系统
import { executeChipSettlement, cleanupSettlementChips, resetSettlementState } from '../ts/chipSettlementAnimation';
// 移除 areaMapping，直接使用 tables 配置

const bankerCards = ref([])
const sectorCards = ref({})

// 执行发牌动画 - 使用背面占位卡牌（用于BETTING阶段）
const executeCardDeal = async (duration = 0.8, shouldDeal = true) => {
  console.log('[发牌] 开始执行, duration:', duration, 'shouldDeal:', shouldDeal, 'tables:', tables.value.length);
  try {
    // BETTING阶段发牌：使用空数据，扑克牌显示背面
    // 创建占位卡牌（ID为0表示背面）
    const placeholderCardIds = [0, 0, 0, 0, 0];

    // 更新响应式数据 - 占位卡牌（背面）
    bankerCards.value = getCardsDetailFromIds(placeholderCardIds);

    // 处理 sectorCards - 所有区域使用占位卡牌（背面）
    const processedSectorCards: Record<string, any[]> = {
      tian: getCardsDetailFromIds(placeholderCardIds),
      di: getCardsDetailFromIds(placeholderCardIds),
      xuan: getCardsDetailFromIds(placeholderCardIds),
      huang: getCardsDetailFromIds(placeholderCardIds)
    };
    sectorCards.value = processedSectorCards;

    // 修复：等待 Vue 渲染完成，确保所有卡牌组件已挂载并设置了 refs
    await nextTick();
    // 额外等待一帧，确保 PokerCard 组件的 :ref 回调已执行
    await new Promise(resolve => requestAnimationFrame(resolve));

    // 根据 shouldDeal 参数决定是否执行发牌动画，传入背面卡牌数据
    await dealCardsWithData(bankerCards.value, sectorCards.value, shouldDeal, duration);

    // 设置发牌标志
    hasDealtCardsThisRound.value = true;
  } catch (error) {
    // 发牌失败静默处理
  }
}

const gameContainer = ref()
const rtp = ref('99.02%')
const indoorHeaderRef = ref<any>()
const trendChartRef = ref() // 走势图组件引用
const chipActive = ref(1)
const chipValue = computed(() => {
  // 使用筹码面值，不乘以倍率
  return chipActive.value;
})

// 筹码列表
import { betChips } from '../ts/gameTps'

// 最小下注限制
const minBetLimit = ref(0)

// 最大下注限制（单个区域总额不能超过此值）
const maxBetLimit = ref(0)

// 防止并发下注的标志
const isBetting = ref(false)

// 筹码 PNG 图片映射
const chipPngMap: Record<number, string> = {
  1: new URL('@/assets/imgs/betcorgi/chip1.png', import.meta.url).href,
  2: new URL('@/assets/imgs/betcorgi/chip2.png', import.meta.url).href,
  5: new URL('@/assets/imgs/betcorgi/chip5.png', import.meta.url).href,
  10: new URL('@/assets/imgs/betcorgi/chip10.png', import.meta.url).href,
  50: new URL('@/assets/imgs/betcorgi/chip50.png', import.meta.url).href,
  100: new URL('@/assets/imgs/betcorgi/chip100.png', import.meta.url).href,
  200: new URL('@/assets/imgs/betcorgi/chip200.png', import.meta.url).href,
  500: new URL('@/assets/imgs/betcorgi/chip500.png', import.meta.url).href,
}

// 获取筹码 PNG 图片路径
const getChipPng = (chipValue: number): string => {
  return chipPngMap[chipValue] || chipPngMap[1]
}

// 判断筹码是否可用（大于等于最小下注限制 且 小于等于余额）
const isChipAvailable = (chipValue: number) => {
  // 如果余额为0，所有筹码不可用
  if (userBalance.value <= 0) {
    return false
  }
  // 筹码必须大于等于最小下注限制，且小于等于余额
  return chipValue >= minBetLimit.value && chipValue <= userBalance.value
}

// 控制折叠面板展开状态
const isExpanded = ref(false)

// 触摸拖动相关状态
const gameMainRef = ref<HTMLElement | null>(null)
const touchStartY = ref(0)

// 触摸开始
const handleTouchStart = (e: TouchEvent) => {
  if (!isExpanded.value) return
  touchStartY.value = e.touches[0].clientY
}

// 触摸移动 - 向下拖动时收起
const handleTouchMove = (e: TouchEvent) => {
  if (!isExpanded.value) return
  const deltaY = e.touches[0].clientY - touchStartY.value
  // 向下拖动超过阈值时收起
  if (deltaY > 30) {
    isExpanded.value = false
  }
}

// 触摸结束
const handleTouchEnd = () => {
  // 空函数，保留以避免模板报错
}

// 滚轮事件处理
const handleWheel = (e: WheelEvent) => {
  if (!isExpanded.value) return
  // 向下滚动（deltaY > 0）时收起展开面板
  if (e.deltaY < 0) {
    isExpanded.value = false
  }
}

// 处理折叠面板展开前的检查
const handleBeforeExpand = () => {
  // 如果不在下注阶段，强制关闭
  if (gameStatus.value !== 'BETTING') {
    // 使用 nextTick 强制关闭
    nextTick(() => {
      isExpanded.value = false
    })
    return false
  }
  return true
}

// 处理折叠面板展开完成后滚动到底部
const handleAfterExpand = () => {
  // 使用 nextTick 确保 DOM 完全更新后再滚动
  nextTick(() => {
    if (gameContainer.value) {
      const container = gameContainer.value
      const targetScroll = container.scrollHeight - container.clientHeight

      // 平滑滚动到底部
      container.scrollTo({
        top: targetScroll,
        behavior: 'smooth'
      })
    }
  })
}

// 处理筹码选择
const handleChipSelect = (chipName: string) => {
  betChips.value.forEach((chip) => {
    chip.active = chip.name === chipName
    if (chipName == chip.name) {
      chipActive.value = chip.value
    }
  })
}

// 下注状态和倒计时相关变量
const showStatus = ref(false) // 游戏状态类型定义
const showNotBettingTip = ref(false) // 控制非下注阶段提示窗口
type GameStatusType = 'PREPARING_NEXT_ROUND' | 'BETTING' | 'STOP_BETTING' | 'SHOW_RESULT' | ''
// 游戏状态变量
const gameStatus = ref<GameStatusType>('') // 下注状态
const countdownValue = ref(0) // 倒计时秒数

// 🎵 音效状态版本号：每次状态切换时递增，用于防止延迟的音效播放
let audioStateVersion = 0;
const getAudioStateVersion = () => audioStateVersion;
const incrementAudioStateVersion = () => ++audioStateVersion;

// 天地玄黄面板
const tables = ref([])

// 🔧 监听 store 配置变化，当配置更新时自动更新 tables
// 原因：EMIT_GET_GAME_CONFIG 回调晚于 EMIT_NIUNIU_JOIN，导致 getTables() 获取不到数据
watch(
  () => joinStateStore.config?.tables,
  (newTables) => {
    console.log('newTables:' + newTables)
    if (newTables && typeof newTables === 'object') {
      const configTables = Object.values(newTables);
      if (configTables.length > 0 && tables.value.length === 0) {
        console.log('[tables watch] 配置更新，设置 tables:', configTables.length, '个区域');
        tables.value = configTables;
      }
    }
  },
  { immediate: true }
);

// 🔧 防止并发加入房间（避免多个重试链同时运行）
let isJoiningRoom = false;

// 初始化游戏函数
const fnJoinTheHall = () => {
  // 如果已经退出房间，不允许加入
  if (isRoomExited.value) {
    return;
  }

  // 🔧 防止并发：如果已有加入操作在进行中，直接返回
  if (isJoiningRoom) {
    console.log('[进入房间] 已有加入操作进行中，跳过本次请求');
    return;
  }
  isJoiningRoom = true;

  // 🔧 重置结算动画状态（允许新房间的结算动画正常运行）
  resetSettlementState();

  // 🎵 重置音效版本号（进入新房间时确保旧音效不会播放）
  incrementAudioStateVersion();
  gameAudio?.stopAll();

  // 记录当前会话版本号，用于检测页面可见性变化
  const currentSessionId = getVisibilitySessionId();

  // 获取路由参数
  const hallName = route?.query?.name as string;
  const rateType = route?.params?.id ? `x${route.params.id}` : '';

  // 参数验证：确保必要参数存在
  if (!hallName || !rateType) {
    showNegativeNotify($tFn('niuniu.EnterGameFailed'));
    setTimeout(() => fnGoToEntrance(), 1500);
    return;
  }

  // 构造房间参数，确保符合NiuniuJoinParams接口
  const params: NiuniuJoinParams = {
    hallName,
    rateType
  };

  // 🔧 重试配置：处理 WebSocket 重连后服务未就绪的情况
  const MAX_RETRY = 3;
  const RETRY_DELAY = 500; // ms
  let retryCount = 0;

  const doJoinRoom = async () => {
    EMIT_NIUNIU_JOIN(params, async (res) => {
      // 会话版本检查：页面可见性变化后中止旧操作
      if (getVisibilitySessionId() !== currentSessionId) {
        console.log('[进入房间] 页面可见性已变化，中止旧的初始化流程');
        isJoiningRoom = false; // 🔧 重置标志
        return;
      }
      
      console.log(res, '进入房间----------')
      
      // 🔧 处理 "Service not found" 错误：WebSocket 重连后服务可能未就绪
      if (res?.error === 'Service not found.' && res?.code === 1002) {
        if (retryCount < MAX_RETRY) {
          retryCount++;
          console.log(`[进入房间] 服务未就绪，${RETRY_DELAY}ms后重试 (${retryCount}/${MAX_RETRY})`);
          setTimeout(doJoinRoom, RETRY_DELAY);
          return;
        } else {
          // 重试次数用尽，刷新页面
          console.log('[进入房间] 重试次数用尽，刷新页面');
          window.location.reload();
          return;
        }
      }
      
      if (res?.['code'] == '3308') { // 余额不足 
        isJoiningRoom = false; // 🔧 重置标志
        fnBackToPortal();
        return;
      }
      // 检查返回数据是否有效
      if (!res || res?.error) {
        isJoiningRoom = false; // 🔧 重置标志
        showNegativeNotify(res?.['error']);
        return;
      }

      gameStatus.value = res?.state?.name as GameStatusType;
      // 处理游戏下注限制 - 添加兜底逻辑确保正确获取币种
      const currency = currentCurrency.value || userStore.$state.currentCurrency;

      const hallLimit = res[currency]?.hallLimit;
      fnCurrentCurrency(hallLimit)

      // 处理游戏状态和倒计时
      handleCountDown(res.state);
      
      // 🔧 修复：只有在 SHOW_RESULT 状态进入房间时才跳过结算动画
      // 原因：SHOW_RESULT 状态下，processFirstEntryResult 会处理结算动画
      //       如果不跳过，会导致两个处理器都执行，动画执行两次
      // 注意：STOP_BETTING 状态进入房间时不应跳过，否则收到 ON_NIUNIU_RESULT 时会直接清空筹码
      if (gameStatus.value === 'SHOW_RESULT') {
        skipChipSettlement.value = true;
        // 延迟重置标志，确保 processFirstEntryResult 的延迟动画执行完毕后才允许新的结算
        const resetDelay = Math.max(5000, countdownValue.value * 1000 + 2000);
        setTimeout(() => {
          skipChipSettlement.value = false;
        }, resetDelay);
      }
      
      // 🔧 页面恢复时重置统计数据，防止与旧数据累加
      areaTotalValues.value = { tian: 0, di: 0, xuan: 0, huang: 0 };
      
      // 🎯 使用接口返回的 sectorTotals 直接设置所有玩家下注统计
      if (res.sectorTotals) {
        allPlayersTotalValues.value = {
          tian: Number(res.sectorTotals.tian) || 0,
          di: Number(res.sectorTotals.di) || 0,
          xuan: Number(res.sectorTotals.xuan) || 0,
          huang: Number(res.sectorTotals.huang) || 0
        };
      } else {
        allPlayersTotalValues.value = { tian: 0, di: 0, xuan: 0, huang: 0 };
      }
      clearDOMChips();
    
      // 🔧 修复：必须 await，确保 SHOW_RESULT 的卡牌动画完成后再处理筹码
      res.roundResult.sectorResultsByRoom = res.sectorResultsByRoom
      await handleInitialGameStatus(gameStatus.value, res.roundResult)
    
      // 监听游戏状态变化 - 使用ON_NIUNIU_STATE事件
      handleGameOnState()

      // 监听其他玩家下注
      handleOtherPlayersBet()

      // 监听游戏结果
      handleGameResult()

      // 监听撤销下注后的在线人数更新
      handleOnCancel()

      // 获取在线人数
      fetchPlayerList()
      lastCurrentRoundBets.value = res?.currentRoundBets || []
      // 处理进入房间时的历史下注数据
      // STOP_BETTING/SHOW_RESULT 状态或页面恢复时：跳过动画，直接在筹码区显示
      // 🔧 倒计时为0且SHOW_RESULT状态时，不显示筹码
      const shouldSkipChips = gameStatus.value === 'SHOW_RESULT' && countdownValue.value === 0;
      if (!shouldSkipChips && res.currentRoundBets && Array.isArray(res.currentRoundBets) && res.currentRoundBets.length > 0) {
        // 修复：STOP_BETTING/SHOW_RESULT 状态始终跳过动画（不需要飞行效果）
        const shouldSkipAnimation = gameStatus.value === 'STOP_BETTING' || gameStatus.value === 'SHOW_RESULT';
        // 延迟一点时间，确保页面元素已经渲染完成
        // STOP_BETTING/SHOW_RESULT 状态使用较短延迟，让筹码尽快显示
        const delay = shouldSkipAnimation ? 100 : 500;
        setTimeout(() => {
          // 🚨 会话版本检查：防止快速切换页面时执行旧数据
          if (getVisibilitySessionId() !== currentSessionId) {
            console.log('[历史下注] 页面可见性已变化，跳过筹码创建');
            return;
          }
          processCurrentRoundBets(res.currentRoundBets, shouldSkipAnimation);
        }, delay);
      }

      // 预加载走势图数据
      loadRoundHistoryData();
      
      // 🔧 加入成功，重置标志
      isJoiningRoom = false;
    });
  };

  // 开始执行加入房间
  doJoinRoom();
}

/**
 * 加载走势图历史数据
 * @description 获取当前房间的最近20条开奖记录，用于走势图展示
 */
const loadRoundHistoryData = () => {
  const hallName = route?.query?.name?.toString() || 'trial';
  const roundHistoryParams: NiuniuRoundHistoryParams = {
    hallName,
    page: 1,
    limit: 20
  };

  EMIT_NIUNIU_ROUND_HISTORY(roundHistoryParams, (res: any) => {
    if (!res || res?.error) {
      return
    }
    if (res?.rounds && res.rounds.length > 0) {
      // 根据实际数据量取值，有几条取几条，最多取5条
      const bankerHistory: any[] = []
      const tianHistory: any[] = []
      const diHistory: any[] = []
      const xuanHistory: any[] = []
      const huangHistory: any[] = []

      // 辅助函数：将牛型转换为显示文本（支持中英文）
      const formatNiuType = (niuType: number) => {
        // 使用 $tFn 获取完整的牌型翻译
        const fullName = $tFn(`niuniu.niuType${niuType}`)

        // 英文环境：去掉 'Bull ' 前缀
        if (locale.value === 'en') {
          // 特殊处理：No Bull → No, Bull Bull → Bull
          if (fullName === 'No Bull') return 'No'
          if (fullName === 'Bull Bull') return 'Bull'
          // 去掉 'Bull ' 前缀，保留数字或其他文字
          if (fullName.startsWith('Bull ')) {
            return fullName.replace('Bull ', '')
          }
          return fullName
        }

        // 中文环境：去掉 '牛' 字
        // 特殊处理：无牛 → 无, 牛牛 → 牛
        if (fullName === '无牛') return '无'
        if (fullName === '牛牛') return '牛'
        if (fullName === '五花牛') return '五花'
        if (fullName === '四炸') return '四炸'
        if (fullName === '五小牛') return '五小'
        // 去掉 '牛' 字，保留数字
        if (fullName.startsWith('牛')) {
          return fullName.replace('牛', '')
        }
        return fullName
      }

      // 取实际数据量和5条中的较小值
      const dataCount = Math.min(res.rounds.length, 5)

      res.rounds.slice(0, dataCount).forEach((round: any) => {
        bankerHistory.push({
          typeId: round.bankerNiuType,
          type: formatNiuType(round.bankerNiuType)
        })
        tianHistory.push({
          typeId: round.sectorResults.tian.niuType,
          type: formatNiuType(round.sectorResults.tian.niuType)
        })
        diHistory.push({
          typeId: round.sectorResults.di.niuType,
          type: formatNiuType(round.sectorResults.di.niuType)
        })
        xuanHistory.push({
          typeId: round.sectorResults.xuan.niuType,
          type: formatNiuType(round.sectorResults.xuan.niuType)
        })
        huangHistory.push({
          typeId: round.sectorResults.huang.niuType,
          type: formatNiuType(round.sectorResults.huang.niuType)
        })
      })

      // 倒序处理，最新的记录在前
      lastRoundResult.value = {
        banker: bankerHistory.reverse(),
        tian: tianHistory.reverse(),
        di: diHistory.reverse(),
        xuan: xuanHistory.reverse(),
        huang: huangHistory.reverse()
      }
    }
  });
}

// 处理能否下注
const fnCurrentCurrency = (data) => {
  // 安全检查
  if (!data) {
    return
  }

  const name = route.query.name || 'trial'
  const rate = 'x' + route.params.id

  // 检查 data[name] 是否存在
  if (!data[name]) {
    return
  }

  // 检查 data[name][rate] 是否存在
  if (!data[name][rate]) {
    return
  }

  const current = data[name][rate]

  const oNowCurrency = userStore.oNowCurrency;
  // 使用 balanceDelay 而不是 balance，与顶部 Wallet.vue 显示保持一致
  const balance = Number(oNowCurrency.balanceDelay);

  // 更新用户余额
  userBalance.value = balance

  // 保存最小下注限制
  const minBet = current.minBet || 0
  minBetLimit.value = Number(minBet)

  // 保存最大下注限制（单个区域总额不能超过此值）
  const maxBet = current.maxBet || 0
  maxBetLimit.value = Number(maxBet)

  // 自动选择第一个可用的筹码（大于等于最小下注限制 且 小于等于余额）
  const availableChips = betChips.value.filter(chip =>
    chip.value >= minBetLimit.value && chip.value <= userBalance.value
  )

  if (availableChips.length > 0) {
    // 取消所有筹码的选中状态
    betChips.value.forEach(chip => chip.active = false)
    // 选中第一个可用筹码
    availableChips[0].active = true
    chipActive.value = availableChips[0].value
  } else {
    // 没有可用筹码，取消所有选中
    betChips.value.forEach(chip => chip.active = false)
    chipActive.value = 0
  }
}

/**
 * Socket监听器关闭函数（参考红包游戏的做法）
 */
let closeOnBet = () => void 0;
let closeOnState = () => void 0;
let closeOnResult = () => void 0;
let closeOnCancel = () => void 0;

// 标志位：防止重复注册
let isBetListenerRegistered = false;
let isResultListenerRegistered = false;

// 🚀 性能优化：限制并发动画数量
let activeAnimationCount = 0;
const MAX_CONCURRENT_ANIMATIONS = 15; // 最多同时15个动画
const animationQueue: Array<() => void> = [];

// 🛡️ 清空动画队列（页面不可见时调用，防止恢复后执行旧任务）
const clearAnimationQueue = () => {
  const queueLength = animationQueue.length;
  animationQueue.length = 0;
  activeAnimationCount = 0;
  if (queueLength > 0) {
    console.log(`[动画队列] 已清空 ${queueLength} 个待执行任务`);
  }
};

// 🚀 处理动画队列
const processAnimationQueue = () => {
  // 🛡️ 页面不可见时跳过动画处理，防止恢复后执行旧任务
  if (!isPageVisible.value) {
    console.log('[动画队列] 页面不可见，跳过动画处理');
    return;
  }

  if (animationQueue.length === 0 || activeAnimationCount >= MAX_CONCURRENT_ANIMATIONS) {
    return;
  }

  const animate = animationQueue.shift();
  if (animate) {
    activeAnimationCount++;
    animate();

    // 继续处理队列
    requestAnimationFrame(processAnimationQueue);
  }
};

// 🚀 动画完成回调
const onAnimationComplete = () => {
  activeAnimationCount = Math.max(0, activeAnimationCount - 1);
  // 尝试处理队列中的下一个
  if (animationQueue.length > 0) {
    requestAnimationFrame(processAnimationQueue);
  }
};

// 注册监听ON_NIUNIU_BET事件 - 接收其他玩家下注数据
const handleOtherPlayersBet = () => {
  // 防止重复注册 - 添加标志位检查（必须在第一行立即检查）
  if (isBetListenerRegistered) {
    return;
  }

  // 立即标记为已注册，防止并发调用
  isBetListenerRegistered = true;

  // 清理旧的监听器
  if (typeof closeOnBet === 'function') {
    closeOnBet();
  }

  // 保存关闭函数
  closeOnBet = ON_NIUNIU_BET((data) => {
    // 如果房间已退出，不处理任何消息
    if (isRoomExited.value) {
      return;
    }

    // 页面恢复可见时，EMIT_NIUNIU_JOIN 会返回 currentRoundBets，包含所有下注数据
    if (!isPageVisible.value) {
      // 只更新在线人数
      if (data.onlineNum !== undefined) {
        onLineCount.value = data.onlineNum;
      }

      return;
    }

    // 检查返回数据是否有效
    if (!data || data?.error) {
      showNegativeNotify(data?.['error']);
      return
    }

    // 🎯 验证币种和房间名称，只处理当前房间的下注数据
    const currentCurrency = pickedCurrency.value;
    const currentHallName = route?.query?.name as string;

    if (data.currency && data.currency !== currentCurrency) {
      // 币种不匹配，静默跳过（防止跨币种数据污染）
      return;
    }

    if (data.hallName && data.hallName !== currentHallName) {
      // 房间名称不匹配，静默跳过（防止跨房间数据污染）
      return;
    }

    // 更新在线人数，同时刷新玩家列表
    if (data.onlineNum !== undefined) {
      onLineCount.value = data.onlineNum;
      // 🎯 同步更新玩家列表数据
      fetchPlayerList();
    }

    // 🔧 新数据格式：sectorAmounts 包含多区域下注，sectorTotals 包含各区域总额
    const { user, sectorAmounts, sectorTotals } = data;
    // 🎯 使用接口返回的 sectorTotals 直接设置所有玩家下注统计
    if (sectorTotals) {
      allPlayersTotalValues.value = {
        tian: Number(sectorTotals.tian) || 0,
        di: Number(sectorTotals.di) || 0,
        xuan: Number(sectorTotals.xuan) || 0,
        huang: Number(sectorTotals.huang) || 0
      };
    }

    // 验证必要字段
    if (!user || !sectorAmounts || typeof sectorAmounts !== 'object') {
      return;
    }

    // 🔍 判断是否是当前用户的下注
    const isCurrentUser = user.id === userId.value;

    if (isCurrentUser) {
      // 当前用户的下注已在 handleAreaClick 中处理，直接返回
      return;
    }

    // 🔧 中文区域名称到拼音的映射
    const chineseToArea: Record<string, string> = {
      '天': 'tian',
      '地': 'di',
      '玄': 'xuan',
      '黄': 'huang'
    };

    // 构建玩家对象（复用）
    const player: Player = {
      name: user.name || 'Unknown',
      avatar: user.avatar || '',
      chipPreference: []
    };

    // 获取在线人数按钮元素（作为起点，复用）
    const onlineButton = document.querySelector('.operate.online') as HTMLElement;

    // 🔧 遍历 sectorAmounts，为每个区域创建下注动画
    Object.entries(sectorAmounts).forEach(([sectorKey, amount]) => {
      const chipAmount = Number(amount);
      if (chipAmount <= 0) return;

      // 转换中文区域名为拼音（如果是中文）
      const areaId = chineseToArea[sectorKey] || sectorKey;

      // 🚀 性能优化：将动画加入队列，控制并发数量
      const animateTask = () => {
        try {
          if (!onlineButton) {
            onAnimationComplete();
            return;
          }

          // 获取目标区域元素
          const targetArea = document.querySelector(`.betting-area[data-area="${areaId}"]`) as HTMLElement;
          if (!targetArea) {
            onAnimationComplete();
            return;
          }

          // 调用其他玩家下注动画函数（传入厅的最小下注限制，用于筹码拆分）
          startOtherPlayerBettingAnimation(
            player,
            areaId,
            chipAmount,
            onlineButton,
            targetArea,
            () => {
              // 动画完成，释放槽位
              onAnimationComplete();
            },
            minBetLimit.value  // 🚀 厅的最小下注限制
          );
        } catch (error) {
          // 出错也要释放槽位
          onAnimationComplete();
        }
      };

      // 添加到队列
      animationQueue.push(animateTask);

      // 将下注数据添加到 lastCurrentRoundBets（用于页面可见性恢复时的比较）
      const betRecord = {
        user: {
          _id: user.id,
          avatar: user.avatar || '',
          lvl: user.lvl || 1,
          name: user.name || 'Unknown'
        },
        amount: chipAmount,
        sector: areaId,
        currency: data.currency || 'cny'
      };
      // 🛡️ 安全检查：确保 lastCurrentRoundBets.value 是数组
      if (!Array.isArray(lastCurrentRoundBets.value)) {
        lastCurrentRoundBets.value = [];
      }
      lastCurrentRoundBets.value.push(betRecord);
    });

    // 尝试立即处理（如果有空闲槽位）
    if (activeAnimationCount < MAX_CONCURRENT_ANIMATIONS) {
      requestAnimationFrame(processAnimationQueue);
    }
  });
}

// ========================================

const reorderCardsWithTenMultiple = (cardIds: number[]) =>
  _reorderCardsWithTenMultiple(cardIds, getCardsDetailFromIds, findTenMultipleCards);

const processAllSectorCards = (sectorCardIds: Record<string, number[]>, shouldReorder: boolean) =>
  _processAllSectorCards(sectorCardIds, shouldReorder, getCardsDetailFromIds, findTenMultipleCards);

const getAllHandTypeInfo = (roundResult: any) => {
  // 获取当前房间倍率类型（如 'x3', 'x5', 'x10'）
  const rateType = route?.params?.id ? `x${route.params.id}` : '';
  return _getAllHandTypeInfo(roundResult, getNiuTypeInfo, rateType);
};

const displayAllHandTypes = (handTypeInfo: any) =>
  _displayAllHandTypes(handTypeInfo, indoorHeaderRef, hallCoverRef);

// ========================================
// 🎯 历史结果处理：主函数
// ========================================

/**
 * 处理游戏状态为开奖阶段的历史结果显示
 * 
 * @param roundResult 上一局的开奖结果数据
 * @param isFirstEntry 是否为首次进入房间
 * 
 * 【首次进入流程】：
 * 1. 初始化卡牌数据并重排（10倍数的3张排到前面）
 * 2. 扑克牌直接显示正面（无发牌、无翻牌动画）
 * 3. 同时显示：开奖结果 + 通吃通赔 + 非下注提示
 * 
 * 【页面可见性处理流程】：
 * 1. 快速发牌（0.1秒，背面朝上）
 * 2. 根据倒计时决定是否重排卡牌
 * 3. 停顿（≤5秒）或直接翻牌（>5秒）
 * 4. 翻牌动画 + 显示开奖结果
 * 5. 延迟显示通吃通赔
 * 6. 显示非下注提示
 */
const processRoundResult = async (roundResult: any) => {
  console.log('[processRoundResult] 开始处理, ', 'roundResult:', roundResult);

  try {
    // 兼容处理：支持大写字段名(BankerCards)和小写字段名(bankerCards)，以及数组和字符串格式
    const getCardIds = (upperKey: string, lowerKey: string): number[] => {
      const value = roundResult[upperKey] || roundResult[lowerKey];
      if (!value) return [];
      // 如果是数组，直接返回
      if (Array.isArray(value)) return value;
      // 如果是字符串，解析
      if (typeof value === 'string') return parseCardIds(value);
      return [];
    };

    const bankerCardIds = getCardIds('BankerCards', 'bankerCards');
    const sectorCardIds = {
      tian: getCardIds('TianCards', 'tianCards'),
      di: getCardIds('DiCards', 'diCards'),
      xuan: getCardIds('XuanCards', 'xuanCards'),
      huang: getCardIds('HuangCards', 'huangCards')
    };

    // 如果使用 sectorCards 对象格式
    if (roundResult.sectorCards) {
      sectorCardIds.tian = roundResult.sectorCards.tian || sectorCardIds.tian;
      sectorCardIds.di = roundResult.sectorCards.di || sectorCardIds.di;
      sectorCardIds.xuan = roundResult.sectorCards.xuan || sectorCardIds.xuan;
      sectorCardIds.huang = roundResult.sectorCards.huang || sectorCardIds.huang;
    }

    console.log('[processRoundResult] 解析后的卡牌数据:', { bankerCardIds, sectorCardIds });

    // 路由到对应的处理函数
      return await processFirstEntryResult(roundResult, bankerCardIds, sectorCardIds);

  } catch (error) {
    console.error('[历史结果] 处理失败:', error);
  }
};

// ========================================
// 进入房间处理开奖结果
// ========================================
const processFirstEntryResult = async (
  roundResult: any,
  bankerCardIds: number[],
  sectorCardIds: Record<string, number[]>
) => {
  
  // 🚨 记录当前会话版本号，用于检测页面可见性变化
  const currentSessionId = getVisibilitySessionId();

  try {
    // 🔧 修复：SHOW_RESULT 阶段刷新页面时，从 roundResult 恢复 sectorTotals
    // 原因：res.sectorTotals 在开奖阶段可能为空，但 roundResult 包含各币种的下注数据
    const hasNoSectorTotals = Object.values(allPlayersTotalValues.value).every(v => v === 0);
    if (hasNoSectorTotals && roundResult) {
      const currency = pickedCurrency.value || 'usdt';
      const currencyCapitalized = currency.charAt(0).toUpperCase() + currency.slice(1);
      const sectorTotalsKey = `sectorTotals${currencyCapitalized}`;
      const sectorTotals = roundResult[sectorTotalsKey];
      
      if (sectorTotals && typeof sectorTotals === 'object') {
        allPlayersTotalValues.value = {
          tian: Number(sectorTotals.tian) || 0,
          di: Number(sectorTotals.di) || 0,
          xuan: Number(sectorTotals.xuan) || 0,
          huang: Number(sectorTotals.huang) || 0
        };
        console.log('[进入房间-开奖] 从 roundResult 恢复下注数据:', allPlayersTotalValues.value);
      }
    }

    // 步骤1：重排并赋值卡牌数据
    bankerCards.value = reorderCardsWithTenMultiple(bankerCardIds);
    sectorCards.value = processAllSectorCards(sectorCardIds, true);

    // 等待Vue完成响应式更新
    await nextTick();
    await new Promise(resolve => setTimeout(resolve, RESULT_TIMING.VUE_UPDATE_WAIT));

    // 🚨 会话版本检查：页面可见性变化后中止旧操作
    if (getVisibilitySessionId() !== currentSessionId) {
      console.log('[进入房间-开奖] ⚠️ 页面可见性已变化，中止卡牌处理');
      return;
    }

    // 步骤2：发牌（无动画，跳过背面翻转）
    // 传递 skipBackFlip: true，避免 dealCardsWithData 将卡牌设置为背面
    await dealCardsWithData(bankerCards.value, sectorCards.value, false, 0, true);
    await nextTick();
    await new Promise(resolve => setTimeout(resolve, RESULT_TIMING.DEAL_COMPLETE_WAIT));

    // 🚨 会话版本检查：发牌后再次检查
    if (getVisibilitySessionId() !== currentSessionId) {
      console.log('[进入房间-开奖] ⚠️ 发牌后页面可见性已变化，中止后续处理');
      return;
    }
    
    // 修复：标记本轮已发牌，防止 handleGameStatusUpdate 重新发牌导致卡牌翻回背面
    hasDealtCardsThisRound.value = true;

    // 步骤3：加载GSAP并设置所有卡牌为正面显示
    const gsap = await loadGSAP();
    if (!gsap) return;

    // 设置所有卡牌为正面显示
    document.querySelectorAll('.pocker .card').forEach(cardEl => {
      const frontEl = cardEl.querySelector('.front') as HTMLElement;
      const backEl = cardEl.querySelector('.back') as HTMLElement;
      if (frontEl && backEl) {
        // 直接设置内联样式为正面显示（front在前，back翻转180度隐藏）
        frontEl.style.transform = 'rotateY(0deg)';
        backEl.style.transform = 'rotateY(180deg)';
        // 同时用 GSAP 设置，确保动画状态一致
        gsap.set(frontEl, { rotationY: 0 });
        gsap.set(backEl, { rotationY: 180 });
      }
    });

    // 步骤4：获取牌型信息（用于判断是否需要移动前三张牌）
    const handTypeInfo = getAllHandTypeInfo(roundResult);

    // 步骤5：设置卡牌zIndex，有牛的区域前3张向上移动（无牛不移动）
    let movedCount = 0;
    ALL_AREAS.forEach(area => {
      // 获取该区域的牌型，niuType === 0 表示无牛
      const areaHandType = handTypeInfo[area as keyof typeof handTypeInfo];
      const hasNiu = areaHandType?.niuType !== 0;
      
      for (let i = 0; i < 5; i++) {
        const cardEl = document.querySelector(getCardSelector(area, i)) as HTMLElement;
        if (cardEl) {
          // 只有有牛的区域才移动前3张牌
          if (hasNiu && i < 3) {
            gsap.set(cardEl, { y: -5, zIndex: i + 1 });
            movedCount++;
          } else {
            gsap.set(cardEl, { zIndex: i + 1 });
          }
        }
      }
    });

    // 步骤6：显示所有牌型
    // 🔧 修复：等待 hallCoverRef.value 准备就绪（ClientOnly 可能导致延迟渲染）
    let waitAttempts = 0;
    while (!hallCoverRef.value?.setHandType && waitAttempts < 10) {
      await new Promise(resolve => setTimeout(resolve, 50));
      waitAttempts++;
    }
    if (hallCoverRef.value?.setHandType) {
      displayAllHandTypes(handTypeInfo);
    }

    // 步骤6：显示获胜区域和通吃通赔（兼容大小写字段名）
    const winningSectorsData = roundResult.WinningSectors || roundResult.winningSectors || '[]';
    const resultWinningSectors = typeof winningSectorsData === 'string' ? JSON.parse(winningSectorsData) : winningSectorsData;
    winningSectors.value = resultWinningSectors;
    // 关闭通吃通赔显示
    if (resultWinningSectors.length === 0 || resultWinningSectors.length === 4) {
      showTakeLoseAllResult.value = true;
    }

    // 步骤7：显示非下注阶段提示
    if (gameStatus.value === 'SHOW_RESULT') {
      showNotBettingTip.value = true;
    }

    // 步骤8：延迟执行筹码结算动画（页面恢复时）
    // 策略：在倒计时快结束时（剩余约4秒）才开始执行，不要刚打开页面就处理
    const remainingTime = countdownValue.value;
    const ANIMATION_DURATION = 4; // 筹码动画需要约4秒
    const delayTime = Math.max(0, (remainingTime - ANIMATION_DURATION) * 1000); // 延迟时间(ms)
    
    console.log('[页面恢复-开奖] 剩余倒计时:', remainingTime, '秒, 延迟执行:', delayTime, 'ms');
    
    if (remainingTime > ANIMATION_DURATION) {
      // 时间充足，延迟到倒计时快结束时再执行筹码结算动画
      // 获取各区域倍数信息（提前获取，避免闭包问题）
      const currentRateType = "x" + route.params.id;
      const sectorResults = roundResult.sectorResultsByRoom?.[currentRateType] || {};
      // 构建下注数据（使用 allPlayersTotalValues）
      const savedAreaBets = ['tian', 'di', 'xuan', 'huang'].map(areaId => ({
        areaId,
        totalBet: allPlayersTotalValues.value[areaId] || 0,
        multiplier: Number(sectorResults[areaId]?.multi) || 1
      }));
      const savedWinningSectors = [...resultWinningSectors];
      
      console.log('[页面恢复-筹码结算] 将在', delayTime, 'ms后执行动画');
      
      // 延迟执行筹码结算动画
      setTimeout(async () => {
        // 🚨 会话版本检查：防止快速切换页面时执行旧的结算动画
        if (getVisibilitySessionId() !== currentSessionId) {
          console.log('[页面恢复-筹码结算] ⚠️ 页面可见性已变化，跳过动画');
          return;
        }
        
        // 再次检查是否还在开奖阶段（防止状态已切换）
        if (gameStatus.value !== 'SHOW_RESULT') {
          console.log('[页面恢复-筹码结算] 状态已切换，跳过动画');
          clearDOMChips();
          return;
        }
        
        try {
          console.log('[页面恢复-筹码结算] 开始执行动画, 下注数据:', savedAreaBets);
          await executeChipSettlement({ winningSectors: savedWinningSectors, areaBets: savedAreaBets, minBetLimit: minBetLimit.value });
          
          // 动画完成后清理显示
          winningSectors.value = null;
          showTakeLoseAllResult.value = false;
        } catch (error) {
          console.error('[页面恢复-筹码结算] 动画执行失败:', error);
          clearDOMChips();
          winningSectors.value = null;
          showTakeLoseAllResult.value = false;
        }
      }, delayTime);
    } else {
      // 时间不足（<=2秒），直接清理筹码
      console.log('[页面恢复-筹码结算] 时间不足，跳过动画直接清理');
      clearDOMChips();
      // 短暂显示后清理
      setTimeout(() => {
        winningSectors.value = null;
        showTakeLoseAllResult.value = false;
      }, 500);
    }

  } finally {
  }
};

// 恢复当前用户的下注数据和筹码显示
const restoreMyBets = (myBets: any[], skipAnimation: boolean) => {
  // 预先缓存区域元素
  const areaElements = new Map<string, HTMLElement>();
  ['tian', 'di', 'xuan', 'huang'].forEach(area => {
    const element = document.querySelector(`.betting-area[data-area="${area}"]`) as HTMLElement;
    if (element) areaElements.set(area, element);
  });

  // 清空下注记录
  activeBets.value = [];

  // 使用批量创建函数（对象池 + DocumentFragment优化）
  const batchBets: Array<{sector: string, amount: number, isCurrentUser: boolean, playerName?: string}> = [];
  
  myBets.forEach(bet => {
    const { amount, sector } = bet;
    const chipAmount = Number(amount);
    
    // 恢复下注记录
    activeBets.value.push({ area: sector, value: chipAmount });
    
    // 添加到批量创建列表
    batchBets.push({
      sector,
      amount: chipAmount,
      isCurrentUser: true
    });
  });
  
  // 批量创建所有筹码（使用DocumentFragment减少重排）
  if (batchBets.length > 0) {
    console.log(`[恢复筹码] 批量创建 ${batchBets.length} 个当前用户筹码`);
    batchCreateChipsSync(batchBets, areaElements);
  }

  console.log('[恢复筹码] 当前用户下注恢复完成:', {
    betsCount: activeBets.value.length,
    areaTotalValues: areaTotalValues.value
  });
};

/**
 * 处理进入房间时的历史下注数据（性能优化版）
 * @param bets currentRoundBets数组
 * @param skipAnimation 是否强制跳过飞行动画（默认false）
 */
const processCurrentRoundBets = (bets: any[], skipAnimation: boolean = false) => {
  // 获取当前玩家的币种
  const playerCurrency = (currentCurrency.value || userStore.$state.currentCurrency).toLowerCase();
  const currentUserId = userId.value;

  console.log('[processCurrentRoundBets] 开始处理:', {
    totalBets: bets.length,
    currentUserId,
    playerCurrency,
    skipAnimation
  });

  // 🔧 修复：只重置当前用户下注统计和清理DOM筹码
  // 注意：allPlayersTotalValues 由接口返回的 sectorTotals 直接设置，不在此处重置
  areaTotalValues.value = { tian: 0, di: 0, xuan: 0, huang: 0 };
  clearDOMChips();

  // 分离当前用户和其他玩家的下注
  const myBets: any[] = [];
  const otherBets: any[] = [];

  bets.forEach(bet => {
    const { user, amount, sector, currency } = bet;
    if (!user || !amount || !sector) return;
    if (currency && currency.toLowerCase() !== playerCurrency) return;
    
    
    if (user._id === currentUserId) {
      myBets.push(bet);
    } else {
      otherBets.push(bet);
    }
  });


  // 恢复当前用户的下注数据和筹码显示
  if (myBets.length > 0) {
    console.log('[页面恢复] 恢复当前用户下注:', myBets.length, '笔');
    restoreMyBets(myBets, skipAnimation);
  }

  // 处理其他玩家下注
  if (otherBets.length === 0) return;

  const shouldPlayAnimation = !skipAnimation && gameStatus.value === 'BETTING';
  
  // 预先缓存所有区域元素
  const areaElements = new Map<string, HTMLElement>();
  ['tian', 'di', 'xuan', 'huang'].forEach(area => {
    const element = document.querySelector(`.betting-area[data-area="${area}"]`) as HTMLElement;
    if (element) areaElements.set(area, element);
  });

  let onlineButton: HTMLElement | null = null;
  if (shouldPlayAnimation) {
    onlineButton = document.querySelector('.operate.online') as HTMLElement;
  }

  const bettingStats = new Map<string, number>();

  if (shouldPlayAnimation && onlineButton) {
    // 🚀 使用批量同时动画函数（所有筹码同时飞行）
    const batchBets: Array<{sector: string, amount: number, playerName: string}> = [];
    
    otherBets.forEach(bet => {
      const { user, amount, sector } = bet;
      const chipAmount = Number(amount);
      const playerName = user.name || 'Unknown';
      bettingStats.set(sector, (bettingStats.get(sector) || 0) + chipAmount);
      
      batchBets.push({
        sector,
        amount: chipAmount,
        playerName
      });
    });
    
    if (batchBets.length > 0) {
      console.log(`[批量动画] 准备同时飞行 ${batchBets.length} 笔下注`);
      batchBettingAnimationSimultaneous(batchBets, onlineButton, areaElements, () => {
        console.log('[批量动画] 所有历史下注动画完成');
      }, minBetLimit.value);  // 厅的最小下注限制
    }
  } else {
    // 使用批量创建函数（对象池 + DocumentFragment优化）
    const batchBets: Array<{sector: string, amount: number, isCurrentUser: boolean, playerName?: string}> = [];
    
    otherBets.forEach(bet => {
      const { user, amount, sector } = bet;
      const chipAmount = Number(amount);
      const playerName = user.name || 'Unknown';
      
      // 将金额拆分成标准筹码组合（根据厅的最小下注限制）
      const chipCombo = splitAmountToChips(chipAmount, minBetLimit.value);
      chipCombo.forEach(({ value, count }) => {
        for (let i = 0; i < count; i++) {
          batchBets.push({
            sector,
            amount: value,
            isCurrentUser: false,
            playerName
          });
        }
      });
    });
    
    // 批量创建所有筹码（使用DocumentFragment减少重排）
    if (batchBets.length > 0) {
      console.log(`[批量创建筹码] 共 ${batchBets.length} 个筹码`);
      batchCreateChipsSync(batchBets, areaElements);
    }
  }

  // ⚠️ 不要在这里更新 allPlayersTotalValues
  // createOtherPlayerPermanentChip 内部已经更新了 allPlayersTotalValues，再更新会导致翻倍
};

const winningSectors = ref(null)

// 控制通吃通赔结果显示（翻牌完成后才显示）
const showTakeLoseAllResult = ref(false)

// 跟踪当前局是否已经发过牌的标志
const hasDealtCardsThisRound = ref(false)

// 🎯 标识是否是静默刷新后的重新加入（用于跳过历史开奖动画）
const isSilentRefresh = ref(false)

// 房间退出标志位 - 用于阻止退出后的异步代码继续执行
const isRoomExited = ref(false)

// 标记是否正在处理首次进入的历史结果 - 防止实时开奖监听干扰
const isProcessingInitialResult = ref(false)

// 🎯 标记是否跳过筹码结算动画（页面恢复时使用）
const skipChipSettlement = ref(false)

/**
 * 处理游戏结果
 */
// ========================================
// 辅助函数：更新庄家牌型
// ========================================
const updateBankerHandType = (banker: any, expectedAudioVersion?: number) => {
  if (isRoomExited.value || !indoorHeaderRef.value) return;

  try {
    const bankerInfo = getNiuTypeInfo(banker);
    indoorHeaderRef.value.bankerHandType = banker.niuType;
    indoorHeaderRef.value.bankerMultiplier = banker.multi;
    indoorHeaderRef.value.bankerHandName = bankerInfo.typeName;
    indoorHeaderRef.value.showBettingResult = true;
    // 播放庄家牛型音效（需验证状态版本、当前状态和房间状态）
    const shouldPlayAudio = !isRoomExited.value &&
      isPageVisible.value && 
      gameStatus.value === 'SHOW_RESULT' &&
      (expectedAudioVersion === undefined || expectedAudioVersion === getAudioStateVersion());
    if (shouldPlayAudio) {
      gameAudio?.playBullType(banker.niuType);
    }
  } catch (error) {
    console.error('[开奖-庄家] 设置失败:', error);
  }
};

// ========================================
// 辅助函数：更新区域牌型
// ========================================
const updateAreaHandType = (areaId: string, sectorResults: any, expectedAudioVersion?: number) => {
  if (isRoomExited.value || !hallCoverRef.value) return;
  if (typeof hallCoverRef.value.setHandType !== 'function') return;

  try {
    const mappedAreaId = AREA_MAPPING[areaId] || areaId;
    const areaData = sectorResults[mappedAreaId];

    if (areaData) {
      const areaInfo = getNiuTypeInfo(areaData);
      hallCoverRef.value.setHandType(mappedAreaId, areaInfo.typeName, areaInfo.niuType, areaInfo.multiplier);
      // 播放区域牛型音效（需验证状态版本、当前状态和房间状态）
      const shouldPlayAudio = !isRoomExited.value &&
        isPageVisible.value && 
        gameStatus.value === 'SHOW_RESULT' &&
        (expectedAudioVersion === undefined || expectedAudioVersion === getAudioStateVersion());
      if (shouldPlayAudio) {
        gameAudio?.playBullType(areaData.niuType);
      }
    } else {
      console.warn(`[开奖] 找不到区域数据: ${mappedAreaId}`);
    }
  } catch (error) {
    console.error(`[开奖-${areaId}] 设置失败:`, error);
  }
};

// ========================================
// 主函数：注册开奖结果监听
// ========================================
const handleGameResult = () => {
  // 防止重复注册
  if (isResultListenerRegistered) {
    return;
  }

  isResultListenerRegistered = true;

  // 清理旧监听器
  if (typeof closeOnResult === 'function') {
    closeOnResult();
  }

  // 订阅开奖结果事件
  closeOnResult = ON_NIUNIU_RESULT(async (result) => {
    // 🎯 第一层过滤：验证厅名，只处理当前厅的开奖数据（静默跳过其他厅）
    const currentHallName = route?.query?.name as string;
    const resultHallName = result?.hallName || result?.HallName;
    if (resultHallName && resultHallName !== currentHallName) {
      // 收到其他房间的开奖消息，静默跳过（不打印日志）
      return;
    }
    console.log(result,'ON_NIUNIU_RESULT')

    // 🎯 根据当前币种获取对应的 sectorTotals（如 sectorTotalsUsdt, sectorTotalsCny 等）
    const currency = pickedCurrency.value || 'usdt';
    const currencyCapitalized = currency.charAt(0).toUpperCase() + currency.slice(1);
    const sectorTotalsKey = `sectorTotals${currencyCapitalized}` as keyof typeof result;
    const sectorTotals = result[sectorTotalsKey];
    
    if (sectorTotals && typeof sectorTotals === 'object') {
      allPlayersTotalValues.value = {
        tian: Number(sectorTotals.tian) || 0,
        di: Number(sectorTotals.di) || 0,
        xuan: Number(sectorTotals.xuan) || 0,
        huang: Number(sectorTotals.huang) || 0
      };
    }

    // 🎯 第二层过滤：页面不可见时，不执行开奖动画（防止动画被暂停导致不连贯）
    if (!isPageVisible.value) {
      console.log('[实时开奖] ⏸️ 页面不可见，跳过本次开奖处理');
      return;
    }

    await handleRealtimeGameResult(result);
  });
};

/**
 * 处理实时开奖结果（ON_NIUNIU_RESULT 事件）
 * 执行完整的开奖过程
 * @param result - 服务器返回的开奖结果数据
 */
const handleRealtimeGameResult = async (result: any) => {
  // 记录当前会话版本号，用于检测页面可见性变化
  const currentSessionId = getVisibilitySessionId();
  
  // 验证：房间退出或数据错误
  if (isRoomExited.value) {
    return;
  }

  if (!result || result['error']) {
    showNegativeNotify(result?.error);
    return;
  }

  // const hasUserBets = activeBets.value.length > 0;
  // const queueTimestamp = hasUserBets ? userStore.queueStart(false) : null;

  try {
    // 1. 获取房间配置和结果数据
    const currentRateType = "x" + route.params.id;
    const sectorResults = result.sectorResultsByRoom?.[currentRateType] || {};
    const bankerNiuType = result.bankerNiuType ?? 0;
    // 🔧 关键：在开奖动画开始时保存下注数据的副本
    // 原因：ON_NIUNIU_STATE 可能在开奖动画期间触发 PREPARING_NEXT_ROUND，导致下注数据被清空
    // 注意：使用 allPlayersTotalValues（所有玩家下注总额）而不是 areaTotalValues（当前玩家下注额）
    const savedAreaBets = ['tian', 'di', 'xuan', 'huang'].map(areaId => ({
      areaId,
      totalBet: allPlayersTotalValues.value[areaId] || 0,
      multiplier: Number(sectorResults[areaId]?.multi) || 1
    }));
    console.log('[筹码结算] 保存下注数据:', savedAreaBets);

    // 2. 设置卡牌数据
    if (result.bankerCards && Array.isArray(result.bankerCards)) {
      bankerCards.value = getCardsDetailFromIds(result.bankerCards);
    }

    if (result.sectorCards) {
      sectorCards.value = Object.fromEntries(
        Object.entries(result.sectorCards).map(([area, cardIds]) =>
          [area, getCardsDetailFromIds(cardIds as number[])]
        )
      );
    }

    // 3. 发牌动画（不排序）
    await dealCardsWithData(bankerCards.value, sectorCards.value, false);
    await nextTick();
    // 等待cardRefs注册完成（Vue组件ref注册是异步的）
    await new Promise(resolve => setTimeout(resolve, 200));

    // 🚨 会话版本检查：页面可见性变化后中止旧操作
    if (getVisibilitySessionId() !== currentSessionId) {
      console.log('[开奖] ⚠️ 页面可见性已变化，中止旧的开奖流程');
      // if (queueTimestamp !== null) userStore.queueDelete(queueTimestamp);
      return;
    }

    // 🎯 标记当前轮次已通过 WebSocket 实时开奖（防止页面可见性恢复时重复处理）
    // ⚠️ 重要：只有在真正开始执行开奖动画（发牌完成）时才标记
    if (result.roundNum) {
      markRealtimeResultProcessed(result.roundNum);
    }

    // 4. 设置获胜区域
    const resultWinningSectors = JSON.parse(result.winningSectors || '[]');
    const winningArea = resultWinningSectors.length > 0 ? resultWinningSectors[0] : '';

    // 记录开奖开始时的音效版本号，用于防止状态切换后的延迟音效播放
    const audioVersionAtStart = getAudioStateVersion();

    // 5. 执行翻牌动画，传入牌型更新回调
    const updateHandType = (areaId: string) => {
      if (areaId === 'banker') {
        updateBankerHandType(sectorResults.banker, audioVersionAtStart);
      } else {
        updateAreaHandType(areaId, sectorResults, audioVersionAtStart);
      }
    };

    const handTypes = await flipCardsAnimation(
      winningArea,
      RESULT_TIMING.FLIP_DELAY,
      updateHandType,
      bankerCards,
      sectorCards,
      // 庄家第五张牌翻完后的回调：显示获胜高亮和通吃通赔
      async () => {
        if (!isRoomExited.value) {
          // 立即显示获胜区域高亮
          winningSectors.value = resultWinningSectors;

          // 延迟显示通吃通赔（只有庄家通吃或通赔才执行）
          if (resultWinningSectors.length === 0 || resultWinningSectors.length === 4) {
            await new Promise(resolve => setTimeout(resolve, 1000));
            if (!isRoomExited.value) {
              showTakeLoseAllResult.value = true;
              // 🎵 播放通吃/通赔音效（需验证状态版本）
              const shouldPlayResultAudio = isPageVisible.value && 
                gameStatus.value === 'SHOW_RESULT' &&
                audioVersionAtStart === getAudioStateVersion();
              if (shouldPlayResultAudio) {
                gameAudio?.playResult(resultWinningSectors.length);
              }
            }
          }
        }
      }
    );

    if (isRoomExited.value) {
      // 房间已退出：删除余额队列（仅在有队列时）
      // if (queueTimestamp !== null) {
      //   userStore.queueDelete(queueTimestamp);
      // }
      return;
    }

    // 🚨 会话版本检查：翻牌动画后再次检查
    if (getVisibilitySessionId() !== currentSessionId) {
      console.log('[开奖] ⚠️ 翻牌后页面可见性已变化，中止后续流程');
      // if (queueTimestamp !== null) userStore.queueDelete(queueTimestamp);
      return;
    }

    // 🎰 执行开奖后筹码结算动画
    try {
      // 🎯 页面恢复时跳过筹码结算动画（新一轮不需要播放上一轮的结算动画）
      if (skipChipSettlement.value) {
        console.log('[筹码结算] ⏭️ 页面恢复模式，跳过筹码结算动画');
        // 直接清理筹码DOM
        clearDOMChips();
      } else {
        // 🔧 使用开奖动画开始时保存的下注数据副本（避免被状态切换清空）
        console.log('[筹码结算] 使用保存的下注数据:', savedAreaBets);

        // 根据获胜区域执行对应的筹码结算动画
        await executeChipSettlement({ winningSectors: resultWinningSectors, areaBets: savedAreaBets, minBetLimit: minBetLimit.value });
      }

      // 🚨 会话版本检查：筹码结算后再次检查
      if (getVisibilitySessionId() !== currentSessionId) {
        console.log('[开奖] ⚠️ 筹码结算后页面可见性已变化，中止后续流程');
        // if (queueTimestamp !== null) userStore.queueDelete(queueTimestamp);
        return;
      }

      // 关闭通吃通赔显示
      if (resultWinningSectors.length === 0 || resultWinningSectors.length === 4) {
        showTakeLoseAllResult.value = false;
      }

      // 清除获胜区域高亮
      winningSectors.value = null;

      // 🌴 最后回收扑克牌（页面恢复时也跳过）
      if (!isRoomExited.value && !skipChipSettlement.value) {
        await collectCards(1000);
      }

    } catch (error) {
      console.error('[🎰 筹码流动动画] 执行失败:', error);
    }

    // 🚨 最终会话版本检查：避免在错误时机执行 resetGame
    if (getVisibilitySessionId() !== currentSessionId) {
      console.log('[开奖] ⚠️ 动画完成后页面可见性已变化，跳过 resetGame');
      // if (queueTimestamp !== null) userStore.queueDelete(queueTimestamp);
      return;
    }

    // 💰 所有动画完成后，立即更新余额
    // if (!isRoomExited.value && queueTimestamp !== null) {
    //   // ⚡ 优化：立即更新余额，不延迟
    //   userStore.queueForward(queueTimestamp);
    //   console.log('[💰 余额更新] 所有动画完成，余额已更新');
    // }
    // resetGame()
  } catch (error) {
    console.error('[开奖] 处理失败:', error);
    // 🎯 开奖失败：删除余额队列，避免阻塞（仅在有队列时）
    // if (queueTimestamp !== null) {
    //   userStore.queueDelete(queueTimestamp);
    // }
  }
};

// ↓ 提示无法进入此厅 
// 新实现 - 使用 useNoticeDialog
const fnBackToPortal = async () => {
  const confirmed = await showNoticeDialog({
    title: $tFn('Note'),                          // 标题
    mainText: $tFn('niuniu.lowBalance'),         // 主文本
    displaySubText: $tFn('niuniu.rechargePrompt'),  // 副文本（可选）
    buttonText: $tFn('niuniu.confirmExit'),       // 确认按钮文字
    persistent: true                            // 是否阻止点击外部关闭
  });

  // 根据用户选择执行操作
  if (confirmed) {
    await Sleep(100);
    fnGoToEntrance(); // 跳转到大厅页
  }
};

// 标志位：防止重复注册
let isCancelListenerRegistered = false;

// 注册监听ON_NIUNIU_CANCEL事件 - 接收撤销下注后的在线人数更新
const handleOnCancel = () => {
  // 防止重复注册
  if (isCancelListenerRegistered) {
    return;
  }
  isCancelListenerRegistered = true;

  // 清理旧的监听器
  if (typeof closeOnCancel === 'function') {
    closeOnCancel();
  }

  // 保存关闭函数
  closeOnCancel = ON_NIUNIU_CANCEL((res) => {
    if (isRoomExited.value) {
      return;
    }
    if (!res || res?.error) {
      return;
    }
    // 更新在线人数
    if (res.onlineNum !== undefined) {
      onLineCount.value = res.onlineNum;
    }
    // 🔧 使用 sectorTotals 更新四个区域的统计值（撤销下注后同步最新数据）
    if (res.sectorTotals) {
      allPlayersTotalValues.value = {
        tian: Number(res.sectorTotals.tian) || 0,
        di: Number(res.sectorTotals.di) || 0,
        xuan: Number(res.sectorTotals.xuan) || 0,
        huang: Number(res.sectorTotals.huang) || 0
      };
    }
  });
}

// 标志位：防止重复注册
let isStateListenerRegistered = false;
// 防止重复事件：记录上一次处理的事件标识
let lastProcessedStateKey = '';

// 注册监听ON_NIUNIU_STATE事件
const handleGameOnState = () => {
  // 防止重复注册 - 添加标志位检查（必须在第一行立即检查）
  if (isStateListenerRegistered) {
    return;
  }

  // 立即标记为已注册，防止并发调用
  isStateListenerRegistered = true;

  // 清理旧的监听器
  if (typeof closeOnState === 'function') {
    closeOnState();
  }

  // 保存关闭函数
  closeOnState = ON_NIUNIU_STATE((data) => {
    // 如果房间已退出，不处理任何消息
    if (isRoomExited.value) {
      return;
    }

    // 检查返回数据是否有效
    if (!data || data?.error) {
      showNegativeNotify(data?.error)
      return
    }

    // 防止重复事件：使用状态名+结束时间作为唯一标识
    const stateKey = `${data.name}-${data.end}`;
    if (stateKey === lastProcessedStateKey) {
      // console.log('[ON_NIUNIU_STATE] 跳过重复事件:', stateKey);
      return;
    }
    lastProcessedStateKey = stateKey;

    // 立即设置游戏状态，减少延迟
    if (data.name) {
      gameStatus.value = data.name as GameStatusType;
    }

    // 立即初始化倒计时
    countdownValue.value = Math.max(0, Math.floor(data.timeLen / 1000));
    console.log(countdownValue.value, '倒计时')

    // 清除原有的状态相关定时器
    clearAllGameTimers()

    // 启动倒计时定时器（这个函数内部会重新计算一次，但没关系）
    handleCountDown(data)

    // 处理状态更新（显示提示等）
    handleGameStatusUpdate(gameStatus.value)
  })
}

// 1. 处理首次进入房间时的初始游戏状态（未接收到ON_NIUNIU_STATE数据时）
const handleInitialGameStatus = async (status, roundResult?: any) => {
  console.log('[游戏初始化] 状态:', status,  '倒计时:', countdownValue.value, 'roundResult:', roundResult ? '有数据' : '无数据');

    switch (status) {
      case 'PREPARING_NEXT_ROUND':
        // 与初始化一致：显示非下注提示
        bettingEnabled.value = false;
        showStatus.value = false;
        showNotBettingTip.value = true;
        break;
        
      case 'BETTING':
        bettingEnabled.value = true;
        if (countdownValue.value == 15) {
          // 倒计时>14：刚开始下注，显示START提示，执行发牌动画
          showStatus.value = true;
          if (isPageVisible.value && !isRoomExited.value) {
            gameAudio?.play('startBet');
          }
          setTimeout(() => { showStatus.value = false; }, 1000);
          await executeCardDeal(0.3, true);  // 🔧 修复：shouldDeal=true 执行发牌动画
        } else {
          // 倒计时<=14：下注进行中，直接显示扑克牌背面（无动画）
          showStatus.value = false;
          await executeCardDeal(0, false);  // 🔧 修复：shouldDeal=false 立即显示
        }
        break;
        
      case 'STOP_BETTING':
        // 与初始化一致：快速发牌，显示STOP，1秒后隐藏
        bettingEnabled.value = false;
        // 播放封盘警告音效 + 停止下注音效（立即播放，无需延迟）
        if (isPageVisible.value && !isRoomExited.value) {
          gameAudio?.play('countdownWarning');
          gameAudio?.play('stopBet');
        }
        await executeCardDeal(0,false);
        showStatus.value = true;
        setTimeout(() => { showStatus.value = false; }, 1000);
        break;
        
      case 'SHOW_RESULT':
        // 倒计时为0时，只显示非下注提示，不做其他处理
        if (countdownValue.value === 0) {
          showNotBettingTip.value = true;
          break;
        }
        
        // 与初始化一致：10倍数牌排前面，同时翻牌，显示结果
        bettingEnabled.value = false;
        showStatus.value = false;
        
        // 根据倒计时决定是否处理开奖结果
        if (countdownValue.value > 2 && roundResult) {
          // 倒计时>3秒：执行开奖结果处理
          await processRoundResult(roundResult);
        } else{
          // 倒计时<=3秒或无数据：只显示扑克牌背面
          await executeCardDeal(0, false);
        }
        showNotBettingTip.value = true;
        break;
    }
    return;
};
// 2. 处理游戏进行中的状态更新（已接收到ON_NIUNIU_STATE数据后）
const handleGameStatusUpdate = async (status) => {
  console.log('status:' + status,'countdown:'+ countdownValue.value)

  // 🎵 状态切换时：递增版本号并停止所有音效，防止旧音效延迟播放
  incrementAudioStateVersion();
  gameAudio?.stopAll();

  switch (status) {
    case 'PREPARING_NEXT_ROUND':
      // a. 准备阶段 - 优化：分阶段清理，避免页面抖动
      bettingEnabled.value = false;
      showStatus.value = false;

      // 新一轮开始，重置游戏进行状态
      joinStateStore.gameRunning = false;
      try {
        // 📦 步骤1：清理定时器（最高优先级，防止泄漏）
        clearHistoryBetTimers();

        // 📦 步骤2：立即隐藏开奖结果（使用 requestAnimationFrame 优化）
        requestAnimationFrame(() => {
          winningSectors.value = null;
          showTakeLoseAllResult.value = false;

          if (indoorHeaderRef.value) {
            indoorHeaderRef.value.bankerHandType = 0;
            indoorHeaderRef.value.bankerHandName = '';
            indoorHeaderRef.value.bankerMultiplier = 1;
            indoorHeaderRef.value.showBettingResult = false;
          }
          if (hallCoverRef.value && hallCoverRef.value.resetHandTypes) {
            hallCoverRef.value.resetHandTypes();
          }
        });

        // 📦 步骤3：检查是否有卡牌需要收回
        const hasCards = document.querySelector('.pocker .card[style*="opacity: 1"]');

        // 📦 步骤4：并行处理收牌和清理任务
        const cleanupTasks = [];

        // 任务1：收牌动画（如果有卡牌且页面可见）
        // 🔧 修复：页面不可见时跳过收牌动画，避免旧的收牌动画在页面恢复后收走新发的牌
        if (hasCards && isPageVisible.value) {
          cleanupTasks.push(
            collectCards(1000).catch(err => {
              console.error('[状态切换-准备阶段] 收牌失败:', err);
            })
          );
        }

        // 任务2：延迟清理筹码DOM（避免与收牌动画冲突）
        setTimeout(() => {
          requestAnimationFrame(() => {
            clearDOMChips();
          });
        }, hasCards ? 200 : 0);

        // 任务4：重置游戏数据（立即执行，不等待）
        hasDealtCardsThisRound.value = false;
        hasRepeatedThisRound.value = false;

        // 🔧 优化：不清空卡牌数据，保留组件引用
        // 原因：清空数据会导致 Vue 卸载 PokerCard 组件，使 cardRefs 失效
        // 收牌动画已将卡牌隐藏（opacity: 0），发牌时会重置并显示
        // bankerCards.value = [];
        // sectorCards.value = { "di": [], "huang": [], "tian": [], "xuan": [] };

        // 清理下注数据和统计
        // 保存本轮下注记录到lastRoundBets，用于下一轮续发功能
        // 重要：只有在有新下注时才更新 lastRoundBets，没有下注时保持不变
        if (!isRepeatingBets.value) {
          if (activeBets.value.length > 0) {
            lastRoundBets.value = [...activeBets.value]
          }
        }

        activeBets.value = [];
        // 注意：不清空 lastRoundBets，保留给下一轮续发功能使用
        areaTotalValues.value = {
          tian: 0,
          di: 0,
          xuan: 0,
          huang: 0
        };
        allPlayersTotalValues.value = {
          tian: 0,
          di: 0,
          xuan: 0,
          huang: 0
        };

        // 重置下注数据（新一轮开始，清空上一轮的下注记录）
        lastCurrentRoundBets.value = [];
        // 注意：不重置 lastProcessedRoundNum！
        // 原因：页面不可见时，此状态可能不触发，需保留轮次号用于恢复可见时的跨轮次检测
        // console.log('[准备阶段] 重置 lastCurrentRoundBets，保留轮次号用于跨轮次检测');

        // 清空玩家列表和在线人数（新一局开始）
        playerListData.value = [];
        onLineCount.value = 0;

        // 等待收牌动画完成（如果有的话）
        if (cleanupTasks.length > 0) {
          await Promise.all(cleanupTasks);
        }

      } catch (error) {
        console.error('[状态切换-准备阶段] 清理失败:', error);
      }

      // 新一局开始，只有在走势图弹窗打开时才刷新数据
      if (isOpenTrendChart.value && trendChartRef.value && trendChartRef.value.loadRoundHistory) {
        trendChartRef.value.loadRoundHistory();
      }
      break;

    case 'BETTING':
      // b. 下注阶段： 进入此阶段时发牌
      bettingEnabled.value = true;
      
      // 进入BETTING阶段时，隐藏非下注阶段提示
      showNotBettingTip.value = false;
      // 获取上一局天地玄黄庄的开奖结果
      loadRoundHistoryData();
      // 进入BETTING阶段时发牌（游戏进行中）
      // if (!hasDealtCardsThisRound.value) {
        executeCardDeal(0.3)
      // }
      // 如果倒计时=15，开始发牌
      if (countdownValue.value == 15) {
        showStatus.value = true;
        // 播放开始下注音效
        if (isPageVisible.value && !isRoomExited.value) {
          gameAudio?.play('startBet');
        }
        setTimeout(() => {
          showStatus.value = false; // 1秒后隐藏START提示
        }, 1000);
      }
      break;

    case 'STOP_BETTING':
      bettingEnabled.value = false;
      showStatus.value = true;
      // 播放封盘警告音效 + 停止下注音效（立即播放，无需延迟）
      if (isPageVisible.value && !isRoomExited.value) {
        gameAudio?.play('countdownWarning');
        gameAudio?.play('stopBet');
      }
      setTimeout(() => {
        showStatus.value = false; // 3秒后隐藏STOP提示
      }, 3000);
      break;

    case 'SHOW_RESULT':
      // d. 开奖阶段
      bettingEnabled.value = false;
      showStatus.value = false;
      break;

    default:
      bettingEnabled.value = false;
      showStatus.value = false;
      break;
  }
};

// 游戏定时器集中管理（必须在 watch 之前定义）
const gameTimers = reactive({
  globalTimer: null,    // 全局统一倒计时器
  startTimer: null,     // START状态定时器
  preparingTimer: null, // 准备阶段定时器
  bettingTimer: null,   // 下注阶段定时器
  stopBettingTimer: null, // 停止下注阶段定时器
  showResultTimer: null,  // 显示结果阶段定时器
  resultTimers: []        // 开奖相关的所有定时器（防止泄漏）
})

// 清除所有游戏定时器
const clearAllGameTimers = () => {
  Object.keys(gameTimers).forEach(key => {
    if (key === 'resultTimers') {
      // 清理开奖定时器数组
      if (Array.isArray(gameTimers[key])) {
        gameTimers[key].forEach(timerId => {
          if (timerId) {
            clearTimeout(timerId);
          }
        });
        gameTimers[key] = [];
      }
    } else if (gameTimers[key]) {
      clearTimeout(gameTimers[key]) // 同时清除setTimeout和setInterval类型的定时器
      clearInterval(gameTimers[key]) // 确保两种定时器都被清理
      gameTimers[key] = null
    }
  })

  // 同时清理历史下注定时器
  clearHistoryBetTimers();
}

// 性能优化：移除immediate避免初始化时不必要的调用
watch(
  countdownValue,
  async (newValue) => {
    // 优化：只在关键值时执行，减少不必要的检查
    console.log(newValue,gameStatus.value)
    if (newValue === 0) {
      // 倒计时结束，清除定时器
      if (gameTimers.globalTimer) {
        clearInterval(gameTimers.globalTimer)
        gameTimers.globalTimer = null
      }
    }
  }
)

// 性能优化：简化watch逻辑，只在状态真正变化时处理
watch(gameStatus, (newStatus, oldStatus) => {
  // 只在进入下注阶段时重置标志
  if (newStatus === 'BETTING' && oldStatus !== 'BETTING') {
    hasRepeatedThisRound.value = false;
    hasCancelledThisRound.value = false;
    isRepeatingBets.value = false;
  }
})

// 处理游戏状态变化和倒计时
// 处理游戏状态变化和倒计时
const handleCountDown = (state: NiuniuGameState) => {
  // 设置游戏状态（使用类型转换确保类型安全）
  if (state.name) {
    gameStatus.value = state.name as GameStatusType;
  }

  // 计算倒计时剩余时间
  const currentTime = Date.now();
  const endTime = state.end;

  // 保存结束时间，用于页面恢复时同步
  currentStateEndTime.value = endTime;

  // 先清除已存在的全局定时器，防止重复创建 
  if (gameTimers.globalTimer) {
    clearInterval(gameTimers.globalTimer)
    gameTimers.globalTimer = null
  }

  // 倒计时
  countdownValue.value = Math.max(0, Math.floor(state.timeLen / 1000));
  // countdownValue.value = Math.max(0, Math.floor((endTime - currentTime) / 1000));

  gameTimers.globalTimer = setInterval(() => {
    if (countdownValue.value > 0) {
      countdownValue.value--

      if (gameStatus.value == 'BETTING' && countdownValue.value < 15) {
        showStatus.value = false
      }
      
      // 下注阶段音效
      if (gameStatus.value === 'BETTING' && isPageVisible.value && !isRoomExited.value) {
        // 倒计时每秒播放滴答声（1-5秒）
        if (countdownValue.value > 0 && countdownValue.value < 6) {
          gameAudio?.play('countdownTick');
        }
      }
    } else {
      // 倒计时结束，清除定时器
      clearInterval(gameTimers.globalTimer)
      gameTimers.globalTimer = null

      // 清空所有下注
      clearAllBets();
    }

  }, 1000)
}

// 清空所有下注
const clearAllBets = () => {
  // ✅ 余额由服务端控制，不需要手动加回
  // 保存本轮下注记录到lastRoundBets，用于续发功能
  // 重要：只有在有新下注时才更新 lastRoundBets，没有下注时保持不变
  if (!isRepeatingBets.value) {
    if (activeBets.value.length > 0) {
      lastRoundBets.value = [...activeBets.value]
    }
  }

  // 清空下注记录
  activeBets.value = []

  // 🎯 使用统一的DOM清理函数（性能优化）
  clearDOMChips();
}

// 🎯 性能优化：保存定时器引用，便于清理
let notBettingTipTimer: ReturnType<typeof setTimeout> | null = null;
// 处理关闭非下注阶段提示
const handleCloseNotBettingTip = () => {
  // 清除定时器
  if (notBettingTipTimer) {
    clearTimeout(notBettingTipTimer);
    notBettingTipTimer = null;
  }
  showNotBettingTip.value = false;
}

// 撤销下注提示
const cancelBettingTip = ref(false)

// 点击撤销下注
const cancelBetting = async () => {
  // 检查是否已经撤销过（本局只能撤销一次）
  if (hasCancelledThisRound.value) {
    return
  }

  // 检查是否在下注阶段
  if (gameStatus.value !== 'BETTING') {
    return
  }

  // 如果续发动画正在进行，等待完成
  if (isRepeatingBets.value) {
    // 等待续发完成（最多等待2秒）
    let waitCount = 0;
    while (isRepeatingBets.value && waitCount < 20) {
      await new Promise(resolve => setTimeout(resolve, 100));
      waitCount++;
    }
  }

  // 检查是否有下注记录可以撤销
  if (activeBets.value.length === 0) {
    return
  }

  const params = {
    hallName: route?.query?.name as string
  }
  EMIT_NIUNIU_CANCEL(params, (res) => {
    if (!res || res?.error) {
      showNegativeNotify(res?.error || $tFn('niuniu.cancelFailed'))
      return
    }

    // 撤销成功，标记本局已撤销
    hasCancelledThisRound.value = true

    // 停止所有下注动画，防止动画完成后继续创建筹码
    stopAllAnimations();

    // 清除当前玩家的筹码DOM（包括永久筹码和飞行中的筹码）
    try {
      // 清除永久筹码
      const currentPlayerChips = document.querySelectorAll('.permanent-chip-container')
      currentPlayerChips.forEach(chip => chip.remove())
      // 清除飞行中的筹码
      const flyingChips = document.querySelectorAll('.flying-chip')
      flyingChips.forEach(chip => chip.remove())
    } catch (error) {
      console.error('[撤销下注] 清除筹码DOM失败:', error)
    }

    // 注意：allPlayersTotalValues 由接口返回的 sectorTotals 直接设置，不在此处手动扣除
    // 撤销下注后，服务器会通过 ON_NIUNIU_BET 广播更新后的 sectorTotals

    // 重置当前玩家的下注统计
    areaTotalValues.value = {
      tian: 0,
      di: 0,
      xuan: 0,
      huang: 0
    }

    // 清空当前玩家的下注记录
    activeBets.value = []

    // 显示撤销成功提示
    cancelBettingTip.value = true

    // 3秒后自动关闭提示
    setTimeout(() => {
      cancelBettingTip.value = false
    }, 3000)
  })
}

// 处理天地玄黄面板区域点击事件
const handleAreaClick = (areaId: string) => {
  // 防止并发下注
  if (isBetting.value) {
    return;
  }

  // 首先检查是否在允许下注的时间
  if (!bettingEnabled.value) {
    // 如果游戏状态不是 BETTING，显示提示窗口
    if (gameStatus.value !== 'BETTING') {
      showNotBettingTip.value = true
      // 🎯 保存定时器引用便于清理
      if (notBettingTipTimer) clearTimeout(notBettingTipTimer);
      notBettingTipTimer = setTimeout(() => {
        showNotBettingTip.value = false
        notBettingTipTimer = null;
      }, 1500);
    }
    return
  }
  // 获取选中的筹码面值
  const betAmount = Number(chipActive.value); // 使用筹码面值

  // 检查筹码是否可用（余额是否足够、是否满足最小下注限制）
  if (!isChipAvailable(betAmount)) {
    showNegativeNotify({
      i18n: 'niuniu.insufficientBalance',
    });
    return;
  }

  // 🎯 使用缓存的计算值（性能优化）
  const newTotalAmount = allAreasTotalBet.value + betAmount;

  // 如果总下注超过限制，则拦截
  if (maxBetLimit.value > 0 && newTotalAmount > maxBetLimit.value) {
    showNegativeNotify({
      i18n: 'niuniu.maxBet',
      options: { maxLimit: maxBetLimit.value }
    });
    return;
  }

  // 验证下注
  const validation = validateBetLocal(betAmount)
  if (!validation.valid) {
    return;
  }

  // 设置下注中标志，防止并发
  isBetting.value = true;

  // ⭐ 验证路由参数
  const hallName = route?.query?.name as string;
  const rateType = route?.params?.id ? `x${route.params.id}` : '';

  const params:any = {
    hallName,
    rateType,
    sectorAmount: {
      [areaId]: betAmount.toString()
    }
  }
  console.log(params,'下注筹码')
  // 使用回调式调用下注接口
  EMIT_NIUNIU_BET(params, (res) => {
    if (!res || res?.error) {
      // 下注失败，显示错误信息
      showNegativeNotify(res?.error || $tFn('niuniu.stopBetting'));

      // 重置下注标志
      isBetting.value = false;
      return;
    }
    // ✅ 下注成功：余额会通过服务端推送 ON_BALANCES 自动更新（watch 监听）
    // 立即更新本地统计值，用于界面显示
    const previousAreaTotal = areaTotalValues.value[areaId] || 0;
    areaTotalValues.value[areaId] = previousAreaTotal + betAmount;
    // 下注成功，立即添加到下注记录（禁用续发按钮）
    const betId = `bet_${Date.now()}`;
    const chipIcon = getChipIcon(betAmount);
    const newBet: BetRecord = {
      id: betId,
      area: areaId,
      value: betAmount,
      chipIcon,
      timestamp: new Date().toISOString()
    };
    activeBets.value.push(newBet);

    // 触发筹码飞行动画
    handleChipFlyAnimation(areaId, { value: betAmount });

    // 标记玩家已参与游戏
    joinStateStore.gameRunning = true;

    // 重置下注标志（在动画回调中处理）
    setTimeout(() => {
      isBetting.value = false;
    }, 100);
  });
}

// 筹码落地回调函数 - 处理下注完成后的逻辑
const onChipLanded = (areaId: string, chipValue: number, finalPosition?: { left: number, top: number }) => {
  // areaId 已经是拼音ID，无需转换
  const pinyinAreaId = areaId;

  // 所以在调用前先减去，让它重新累加（保持原有逻辑不变）
  const currentTotal = areaTotalValues.value[areaId] || 0;
  areaTotalValues.value[areaId] = currentTotal - chipValue;

  // 创建永久筹码显示
  try {
    // 获取目标区域元素 - 使用拼音ID查找DOM
    const targetElement = document.querySelector(`.betting-area[data-area="${pinyinAreaId}"]`) as HTMLElement;
    if (!targetElement) {
      console.error('找不到目标区域元素，无法创建永久筹码:', pinyinAreaId);
      // 尝试使用备用选择器
      const backupTarget = document.querySelector(`[data-area="${pinyinAreaId}"] .betting-area`) as HTMLElement;
      if (backupTarget) {
        bettingAnimation.createPermanentChip(areaId, chipValue, backupTarget, finalPosition);
      } else {
        console.error('找不到任何匹配的目标区域元素');
        // 如果找不到元素，需要加回来
        areaTotalValues.value[areaId] = currentTotal;
      }
      return;
    }

    // 调用bettingAnimation中的函数创建永久筹码，传递位置避免重复计算
    bettingAnimation.createPermanentChip(areaId, chipValue, targetElement, finalPosition);
  } catch (error) {
    console.error('创建永久筹码时发生错误:', error);
  }

}

// 筹码飞行动画处理函数
const handleChipFlyAnimation = async (areaId, chipData) => {
  try {

    // 获取验证结果
    const validation = validateBetLocal(chipData.value)
    if (!validation.valid) {
      return false
    }

    // 获取目标区域元素
    if (!areaId) {
      console.error('无效的区域ID')
      onChipLanded(areaId, chipData.value)
      return false
    }

    // 获取源筹码元素（底部选中的筹码）
    let sourceChip = document.querySelector('.chip-item.chip-active')
    if (!sourceChip) {
      console.error('未找到选中的筹码元素');
      return false;
    }

    // 获取目标区域元素 - 使用拼音查找（因为DOM中是拼音）
    let targetElement = document.querySelector(`.betting-area[data-area="${areaId}"]`) as HTMLElement;

    // 如果找不到，尝试不同的选择器
    if (!targetElement) {
      targetElement = document.querySelector(`[data-area="${areaId}"] .betting-area`) as HTMLElement;
    }

    // 如果仍然找不到，尝试查找所有betting-area并打印它们的data-area属性
    if (!targetElement) {
      const allAreas = document.querySelectorAll('.betting-area');
      allAreas.forEach(area => {
      });

      // 尝试查找所有带有data-area属性的元素
      const allDataAreas = document.querySelectorAll('[data-area]');
      allDataAreas.forEach(area => {
      });

      // 无法找到目标元素时，仍然执行下注逻辑
      onChipLanded(areaId, chipData.value);
      return false;
    }

    // 创建简单对象，确保不传递代理对象给动画函数
    const chipDataClean = {
      value: Number(chipData.value)
    };

    // 调用bettingAnimation中的筹码飞行动画函数（使用拼音ID）
    await startChipFlyAnimation(
      areaId,
      chipDataClean,
      sourceChip as HTMLElement,
      targetElement,
      onChipLanded
    );

    return true;
  } catch (error) {
    console.error('处理筹码飞行动画时出错:', error);
    // 错误时也执行下注逻辑，确保业务流程完整
    onChipLanded(areaId, chipData.value);
    return false;
  }
}

// 下注验证逻辑 - 结合bettingAnimation的验证函数和本地状态
// 为了确保类型安全，还需要维护一个本地版本
const validateBetLocal = (chipValue: number): { valid: boolean, message: string } => {
  // 首先检查用户余额 (这是本地独有的状态)
  if (chipValue > userBalance.value) {
    return { valid: false, message: '余额不足' }
  }
  // 然后使用composable中的validateBet进行其他检查
  return validateBet(chipValue, userBalance.value)
}

// 退出游戏函数
const fnExitGame = async () => {
  try {
    // 构造退出参数
    const params = {
      hallName: route?.query?.name?.toString() || 'trial'
    };

    // 立即清除游戏状态和定时器（不等待回调）
    clearAllGameTimers();

    // 停止所有动画
    stopAllCardAnimations(); // 停止卡牌翻牌动画
    stopAllAnimations(); // 停止筹码飞行动画

    // 立即重置倒计时和游戏状态
    countdownValue.value = 0;
    gameStatus.value = '';
    bettingEnabled.value = false;


    // 调用退出接口（通知服务器）
    EMIT_NIUNIU_EXIT(params, (res) => {
    });
  } catch (error) {
    console.error('退出游戏异常:', error);
    // 发生异常时也尝试返回大厅
    router.push('/casino/niuniuGame');
  }
}


// 下注系统状态管理
const bettingEnabled = ref(false) // 下注功能开关
const userBalance = ref(0) // 用户余额
const bettingRecords = ref<Record<string, number>>({}) // 各区域下注总金额

// ⭐ 监听服务端余额推送，实时同步到本地余额
// 使用 balanceDelay 而不是 balance，与顶部 Wallet.vue 显示保持一致
// balanceDelay 会等待队列推进（开奖动画完成）后才更新
watch(
  () => userStore.oNowCurrency.balanceDelay,
  (newBalance) => {
    userBalance.value = Number(newBalance);
    // console.log('💰 [余额同步] userBalance 已更新为:', newBalance);
  },
  { immediate: true } // 立即执行一次，确保初始值和页面恢复时都能同步
)

// 🎯 性能优化：缓存所有区域总下注金额的计算
const allAreasTotalBet = computed(() => {
  return tables.value.reduce((sum, table) => {
    return sum + (areaTotalValues.value[table.name] || 0);
  }, 0);
});

// 下注统计信息
const bettingStats = ref({
  totalBet: 0, // 总下注金额
  chipCounts: { // 各面额筹码数量
    1: 0,
    2: 0,
    5: 0,
    10: 0,
    50: 0
  },
  areaBets: { // 各区域下注情况（使用拼音键）
    tian: { total: 0, betChips: [] },
    di: { total: 0, betChips: [] },
    xuan: { total: 0, betChips: [] },
    huang: { total: 0, betChips: [] }
  }
})

const hallCoverRef = ref<InstanceType<typeof HallCover> | null>(null)

// 计算撤销按钮是否禁用
const isCancelButtonDisabled = computed(() => {
  // 条件1: 不在下注阶段
  if (gameStatus.value !== 'BETTING') return true

  // 条件2: 本轮已经撤销过
  if (hasCancelledThisRound.value) return true

  // 条件3: 没有下注记录可以撤销
  if (activeBets.value.length === 0) return true

  return false
})

// 计算续发按钮是否禁用
const isRepeatButtonDisabled = computed(() => {
  // 条件1: 不在下注阶段
  if (gameStatus.value !== 'BETTING') return true

  // 条件2: 没有上一轮的下注记录
  if (lastRoundBets.value.length === 0) return true

  // 条件3: 本轮已经续发过
  if (hasRepeatedThisRound.value) return true

  // 条件4: 本轮已经有下注记录（在天地玄黄上面已经下注过）
  if (activeBets.value.length > 0) return true

  return false
})

/**
 * 续发功能 - 清空结果并直接开始新一轮
 * 点击续发按钮时调用
 */
const handleContinueGame = async () => {
  // 🚨 第一步：点击续发按钮时立即检查游戏状态
  if (gameStatus.value !== 'BETTING') {
    showNegativeNotify($tFn('niuniu.notBettingPhase'));
    return
  }

  if (lastRoundBets.value.length === 0) {
    showNegativeNotify($tFn('niuniu.noLastRoundBets'));
    return
  }

  // 计算总下注金额
  const totalBetAmount = lastRoundBets.value.reduce((sum, bet) => sum + bet.value, 0)

  // 检查余额是否足够
  if (userBalance.value < totalBetAmount) {
    showNegativeNotify($tFn('niuniu.insufficientBalanceForRedeal', { amount: totalBetAmount }));
    return
  }

  isRepeatingBets.value = true

  // ⭐ 验证路由参数
  const hallName = route?.query?.name as string;
  const rateType = route?.params?.id ? `x${route.params.id}` : '';

  // 🎯 性能优化：构建 sectorAmount 批量下注，一次性发送请求
  const sectorAmount: Record<string, string> = {};

  // 合并同区域下注金额
  lastRoundBets.value.forEach(bet => {
    const currentAmount = parseFloat(sectorAmount[bet.area] || '0');
    sectorAmount[bet.area] = (currentAmount + bet.value).toString();

    // ⭐ 立即更新当前用户统计值：确保续发期间的限额检查准确
    const currentAreaTotal = areaTotalValues.value[bet.area] || 0;
    areaTotalValues.value[bet.area] = currentAreaTotal + bet.value;
    // 注意：allPlayersTotalValues 由接口返回的 sectorTotals 直接设置，不在此处累加

    const newBet: BetRecord = {
      id: `bet_${Date.now()}_${Math.random()}`,
      area: bet.area,
      value: bet.value,
      chipIcon: getChipIcon(bet.value),
      timestamp: new Date().toISOString()
    };
    activeBets.value.push(newBet);
  });

  const params = {
    hallName,
    rateType,
    sectorAmount
  };

  // 单次批量下注请求
  let betSuccess = false;
  await new Promise<void>((resolve) => {
    EMIT_NIUNIU_BET(params, (res) => {
      if (!res || res?.['error']) {
        showNegativeNotify(res?.['error']);
        betSuccess = false;
      } else {
        betSuccess = true;
      }
      resolve();
    });
  });

  // 如果下注失败，回滚乐观更新并禁用续发
  if (!betSuccess) {
    // 回滚当前用户统计值
    lastRoundBets.value.forEach(bet => {
      areaTotalValues.value[bet.area] = Math.max(0, (areaTotalValues.value[bet.area] || 0) - bet.value);
      // 注意：allPlayersTotalValues 由接口返回的 sectorTotals 直接设置，不在此处回滚
    });
    // 回滚 activeBets（移除刚添加的记录）
    const addedCount = lastRoundBets.value.length;
    activeBets.value.splice(-addedCount, addedCount);
    // 清空上轮记录，禁止下一局继续点击续发
    lastRoundBets.value = [];
    isRepeatingBets.value = false;
    hasRepeatedThisRound.value = true; // 标记已尝试过，禁用按钮
    return;
  }

  // 合并各区域下注金额（用于批量动画）
  const mergedSectorAmounts: Record<string, number> = {};
  lastRoundBets.value.forEach(bet => {
    mergedSectorAmounts[bet.area] = (mergedSectorAmounts[bet.area] || 0) + bet.value;
  });

  // 🔧 修复：不再预减统计值，因为筹码数量限制可能导致 updateBettingStats 不会为所有金额调用
  // areaTotalValues 已经在上面的 forEach 中正确设置，无需再次操作

  // 查找源筹码元素
  const sourceChip = document.querySelector('.chip-item.chip-active') || document.querySelector('.chip-item');
  
  // 构建区域元素Map
  const areaElements = new Map<string, HTMLElement>();
  ['tian', 'di', 'xuan', 'huang'].forEach(area => {
    const el = document.querySelector(`.betting-area[data-area="${area}"]`) as HTMLElement;
    if (el) areaElements.set(area, el);
  });

  if (sourceChip && gameStatus.value === 'BETTING') {
    // 调用批量动画
    await batchCurrentPlayerBettingAnimation(
      mergedSectorAmounts,
      sourceChip as HTMLElement,
      areaElements,
      undefined,
      minBetLimit.value
    );
  } else {
    // 状态已变化或找不到源元素，直接创建筹码（跳过统计更新，因为已在上面设置）
    Object.entries(mergedSectorAmounts).forEach(([area, amount]) => {
      const targetArea = areaElements.get(area);
      if (targetArea) {
        // 拆分金额为筹码
        const chipCombo = splitAmountToChips(amount, minBetLimit.value);
        chipCombo.forEach(({ value, count }) => {
          for (let i = 0; i < count; i++) {
            bettingAnimation.createPermanentChip(area, value, targetArea, undefined, true);
          }
        });
      }
    });
  }

  isRepeatingBets.value = false;
  hasRepeatedThisRound.value = true; // 标记本轮已续发
}

/**
 * 重置游戏状态，准备下一轮
 */
const resetGame = async () => {
  try {
    // ⭐ 首先清理所有定时器，防止泄漏
    clearHistoryBetTimers();

    // 🔍 检查页面上是否有可见的卡牌
    const hasVisibleCards = document.querySelector('.pocker .card[style*="opacity: 1"]');

    // 收牌
    if (hasVisibleCards) {
      await collectCards();
    }
    // 🔧 优化：不清空卡牌数据，保留组件引用
    // 原因：清空数据会导致 Vue 卸载 PokerCard 组件，使 cardRefs 失效
    // 收牌动画已将卡牌隐藏（opacity: 0），发牌时会重置并显示
    // bankerCards.value = [];
    // sectorCards.value = { "di": [], "huang": [], "tian": [], "xuan": [] };

    // 重置发牌标志，准备下一局
    hasDealtCardsThisRound.value = false

    // 清空获胜区域数据，避免显示上一轮结果
    winningSectors.value = null
    // 重置通吃通赔显示标志
    showTakeLoseAllResult.value = false
    // 重置续发标志，允许新一轮续发
    hasRepeatedThisRound.value = false


    // 🎯 重置玩家列表数据，准备新一轮
    playerListData.value = [];
    // 在线人数归0
    onLineCount.value = 0

    // 重置下注记录对象
    bettingRecords.value = {}

    // 重置区域下注统计（clearAllBets已经处理，这里确保完全重置）
    areaTotalValues.value = {
      tian: 0,
      di: 0,
      xuan: 0,
      huang: 0
    }

    // 重置所有玩家下注统计
    allPlayersTotalValues.value = {
      tian: 0,
      di: 0,
      xuan: 0,
      huang: 0
    }

    // 3. 清除开奖结果显示
    try {
      if (hallCoverRef.value && hallCoverRef.value.resetHandTypes) {
        hallCoverRef.value.resetHandTypes()
      }
    } catch (error) {
      console.error('[重置游戏] 清除牌型结果失败:', error)
    }

    // 4. 🎯 使用统一的DOM清理函数（性能优化）
    try {
      clearDOMChips();
    } catch (error) {
      console.error('[重置游戏] 清除筹码失败:', error);
    }

    // 6. 清除IndoorHeader中庄家的牌型和结果显示
    try {
      if (indoorHeaderRef.value) {
        indoorHeaderRef.value.bankerHandType = 0
        indoorHeaderRef.value.bankerHandName = ''
        indoorHeaderRef.value.bankerMultiplier = 1
        indoorHeaderRef.value.showBettingResult = false
      }
    } catch (error) {
      console.error('[重置游戏] 清除庄家结果失败:', error)
    }

  } catch (error) {
    console.error('重置游戏状态时出错:', error)
    // 出错时强行重新启用下注
    bettingEnabled.value = true
  }
}

/**
 * 清理房间资源的公共函数
 * 用于切换房间和退出页面时调用
 * @param rejoinRoom 是否重新加入房间（切换房间时为true，退出页面时为false）
 */
const cleanupRoomResources = async (rejoinRoom = false) => {
  try {

    // 设置退出标志，阻止后续异步代码执行
    isRoomExited.value = true;

    // 🔧 立即清空DOM筹码和统计值（在退出房间之前）
    clearDOMChips();
    areaTotalValues.value = { tian: 0, di: 0, xuan: 0, huang: 0 };
    allPlayersTotalValues.value = { tian: 0, di: 0, xuan: 0, huang: 0 };
    activeBets.value = [];
    lastRoundBets.value = [];

    // 停止所有动画
    stopAllAnimations();
    cleanupSettlementChips(); // 🔧 清理筹码结算动画
    cleanupFlyingChips(); // 🔧 清理飞行中的筹码
    
    // 🎵 停止所有音效并重置版本号（切换房间和退出房间都需要）
    gameAudio?.stopAll();
    incrementAudioStateVersion(); // 防止旧房间的延迟音效播放
    
    // 销毁游戏音效（仅退出房间时）
    if (!rejoinRoom) {
      gameAudio?.destroy();
    }

    // 关闭所有Socket监听器
    if (typeof closeOnBet === 'function') closeOnBet();
    if (typeof closeOnState === 'function') closeOnState();
    if (typeof closeOnResult === 'function') closeOnResult();
    if (typeof closeOnCancel === 'function') closeOnCancel();  // 🔧 修复遗漏

    // 重置所有监听器注册标志位
    isBetListenerRegistered = false;
    isStateListenerRegistered = false;
    isResultListenerRegistered = false;
    isCancelListenerRegistered = false;  // 🔧 修复遗漏

    // 3. 清除所有定时器（包括历史下注定时器）
    clearAllGameTimers();
    clearHistoryBetTimers();

    // 4. 通知服务器退出当前房间
    await fnExitGame();

    // 5. 等待退出完成
    await new Promise(resolve => setTimeout(resolve, 300));

    // 6. 重置所有游戏状态
    hasDealtCardsThisRound.value = false;
    winningSectors.value = null;
    hasRepeatedThisRound.value = false;
    lastRoundBets.value = [];
    activeBets.value = [];
    areaTotalValues.value = {
      tian: 0,
      di: 0,
      xuan: 0,
      huang: 0
    };
    allPlayersTotalValues.value = {
      tian: 0,
      di: 0,
      xuan: 0,
      huang: 0
    };
    gameStatus.value = 'PREPARING_NEXT_ROUND';
    countdownValue.value = 0;
    showStatus.value = false;
    showNotBettingTip.value = false;  
    // 🔧 清理非下注提示定时器
    if (notBettingTipTimer) {
      clearTimeout(notBettingTipTimer);
      notBettingTipTimer = null;
    }
    bettingEnabled.value = false;

    // 7. 清理卡牌数据
    bankerCards.value = [];
    sectorCards.value = {
      "di": [],
      "huang": [],
      "tian": [],
      "xuan": []
    };

    // 8. 重置组件状态（使用暴露的方法）
    if (hallCoverRef.value?.resetHandTypes) {
      hallCoverRef.value.resetHandTypes();
    }
    if (hallCoverRef.value?.resetCardRefs) {
      hallCoverRef.value.resetCardRefs();
    }

    // 9. 清空开奖结果显示
    // 清空庄家牌型和结果显示
    if (indoorHeaderRef.value) {
      indoorHeaderRef.value.bankerHandType = 0
      indoorHeaderRef.value.bankerHandName = ''
      indoorHeaderRef.value.bankerMultiplier = 1
      indoorHeaderRef.value.showBettingResult = false
    }
    // 清空区域结果显示
    if (hallCoverRef.value) {
      hallCoverRef.value.showBettingResult = false;
      // 清空所有区域的牌型显示（使用动态区域列表）
      if (typeof hallCoverRef.value.setHandType === 'function') {
        tables.value.map(t => t.name).forEach(area => {
          try {
            hallCoverRef.value.setHandType(area, '');
          } catch (e) {
            // 忽略错误
          }
        });
      }
    }

    // 10. 🎯 使用统一的DOM清理函数（性能优化）
    clearDOMChips();
    // 10.1 清理新的飞行筹码动画
    cleanupFlyingChips();

    // 11. 如果需要，重新加入新房间（仅切换房间或静默刷新时）
    if (rejoinRoom) {
      // 🎯 设置静默刷新标志（用于跳过历史开奖动画）
      isSilentRefresh.value = true;

      // 重置退出标志，允许新房间的代码执行
      isRoomExited.value = false;
      fnJoinTheHall();
    }

  } catch (error) {
    console.error(`${rejoinRoom ? '[切换房间]' : '[退出房间]'} ❌ 清理失败:`, error);
  }
}

/**
 * 监听路由参数变化，处理房间切换
 * 注意：在Nuxt3中，query参数变化时组件不会重新创建，需要手动清理和重新初始化
 */
watch(
  () => route.query.name,
  async (newName, oldName) => {
    // 首次进入不处理
    if (!oldName) return;

    // 房间名没变化不处理
    if (newName === oldName) return;

    // 如果新房间名为空，说明是退出操作，不重新加入房间
    if (!newName) {
      await cleanupRoomResources(false);
      return;
    }


    // 调用公共清理函数，并重新加入房间
    await cleanupRoomResources(true);
  }
)

const scaleRatio = ref(1)

/**
 * 调整窗口大小时更新宽度
 */
const onResize = (): void => {
    if (gameContainer.value && gameContainer.value.offsetWidth) {
        const baseWidth = 375
        const baseHeight = 812
        const baseFontSize = 16
        
        const containerWidth = gameContainer.value.offsetWidth
        const containerHeight = gameContainer.value.offsetHeight
        
        // 根据宽度计算基础 font-size
        let fontSize = (containerWidth / baseWidth) * baseFontSize
        
        // 如果高度不足，按高度比例缩小
        if (containerHeight < baseHeight) {
            const heightRatio = containerHeight / baseHeight
            fontSize = fontSize * heightRatio
        }
        
        // 设置 html 的 font-size 实现 rem 缩放
        document.documentElement.style.fontSize = `${fontSize}px`
        // 设置缩放比例变量，供 CanvasText 等组件使用
        scaleRatio.value = fontSize / baseFontSize
        
    }
}

// 保存当前游戏状态的结束时间，用于页面恢复时同步
const currentStateEndTime = ref(0)
const lastCurrentRoundBets = ref([])
const lastProcessedRoundNum = ref<number>(0)

// 页面可见时清空页面数据（注意：现在只在页面可见时调用，不在隐藏时调用）
const clearPageData = () => {
  console.log('[页面可见] 清空旧数据，准备重新初始化');
  
  // 重置状态事件去重标记，确保新的状态事件不被跳过
  lastProcessedStateKey = '';
  
  // 清理卡牌动画引用，确保新的发牌动画能正常执行
  clearCardRefs();
  
  // 清空卡牌数据
  bankerCards.value = [];
  sectorCards.value = { di: [], huang: [], tian: [], xuan: [] };
  hasDealtCardsThisRound.value = false;
  
  // 清空下注统计
  areaTotalValues.value = { tian: 0, di: 0, xuan: 0, huang: 0 };
  allPlayersTotalValues.value = { tian: 0, di: 0, xuan: 0, huang: 0 };
  activeBets.value = [];
  lastCurrentRoundBets.value = [];
  
  // 清空UI状态 - 开奖结果显示
  winningSectors.value = null;
  showTakeLoseAllResult.value = false;
  showNotBettingTip.value = false;
  showStatus.value = false;
  
  // 清空牌型显示
  if (hallCoverRef.value?.resetHandTypes) {
    hallCoverRef.value.resetHandTypes();
  }
  if (indoorHeaderRef.value) {
    indoorHeaderRef.value.bankerHandType = 0;
    indoorHeaderRef.value.bankerHandName = '';
    indoorHeaderRef.value.bankerMultiplier = 1;
    indoorHeaderRef.value.showBettingResult = false;
  }
  // 清空区域开奖结果
  if (hallCoverRef.value) {
    hallCoverRef.value.showBettingResult = false;
  }
  
  // 清空DOM筹码
  clearDOMChips();
};

// 🔧 重置加入房间标志（供 visibilityHandler 在页面隐藏时调用）
const resetJoiningFlag = () => {
  isJoiningRoom = false;
};

// 页面可见性变化处理 - 简化版：直接复用 fnJoinTheHall 初始化逻辑
const handleVisibilityChange = createVisibilityHandler({
  oMusic,
  gameAudio,  // 游戏音效管理器，页面隐藏时停止音效
  gameTimers,
  clearHistoryBetTimers,
  cleanupRoomResources,
  fnJoinTheHall,
  clearPageData,
  settingStore,  // 声音设置，用于判断页面恢复时是否播放BGM
  resetJoiningFlag,  // 页面隐藏时重置加入标志，确保下次可见时能重新加入
  cleanupSettlementChips,  // 页面隐藏时停止筹码结算动画
  clearAnimationQueue,  // 页面隐藏时清空动画队列，防止恢复后执行旧任务
  clearDOMChips,  // 页面隐藏时清除所有筹码DOM，确保恢复时无旧筹码干扰
});

onMounted(async () => {
  try {
    // 重置退出标志，允许页面正常运行
    isRoomExited.value = false;

    await loadGSAP() //加载GSAP

    // tables 配置由 watch 自动处理（监听 joinStateStore.config.tables 变化）
    // 无需在这里手动获取，watch 会在配置更新时自动设置 tables

    // 初始化币种
    currentCurrency.value = userStore.$state.currentCurrency

    fnJoinTheHall() //加入房间

    await nextTick()
    toCloseLoading()
    onResize()
    window.addEventListener("resize", onResize)

    // 添加页面可见性监听
    document.addEventListener('visibilitychange', handleVisibilityChange)
  } catch (error) {
    console.error('[页面初始化] 初始化失败:', error)
  }
})

// ↓ 询问离开游戏的计数器，防止重复弹窗
let niuniuAskSum = 0;
// ↓ 保存第一次尝试跳转的目标路径
let niuniuPendingNavigation = null;

/**
 * 路由离开守卫 - 牛牛游戏使用自己的拦截逻辑
 * 逻辑与全局中间件保持一致：只拦截往前跳一级的情况
 */
onBeforeRouteLeave(async (to, from, next) => {
  if (!import.meta.client) return;
  // 如果已经退出过房间，直接允许导航（避免重复处理）
  if (isRoomExited.value) {
    return next();
  }

  // 检查游戏是否正在进行
  if (joinStateStore.gameRunning) {
    // 如果已经询问过，阻止导航但不累积历史记录
    if (niuniuAskSum > 0) {
      console.log('[路由守卫] 弹窗已显示，阻止重复导航');
      return next(false); // 阻止导航
    }

    // 保存第一次尝试跳转的目标路径
    niuniuPendingNavigation = to;

    // 询问计数器加1
    niuniuAskSum = niuniuAskSum + 1;

    // 🔒 临时禁用浏览器返回事件，防止弹窗期间累积历史记录
    const originalPopstateHandler = window.onpopstate;
    window.onpopstate = null;
    console.log('[路由守卫] 已临时禁用浏览器返回事件');

    try {
      // 弹出确认弹窗
      const result = await showNoticeDialog({
        title: $tFn('Note'),
        mainText: $tFn('exitGame.gameRunning'),
        mainTextStyle: 'font-size: 12px;font-weight: 600;line-height: 18px;',
        giftIcon: false,
        cancelButtonText: $tFn('exitGame.confirm'), // 确认离开
        buttonText: $tFn('exitGame.cancel'),        // 取消（继续游戏）
        themeStyle: 'border-color:#FF7F00;padding:15px 6px 11px 10px;border-width:1px;',
        dogImage: new URL('@/assets/imgs/orange-npc.webp', import.meta.url).href,
        bgImage: new URL('@/assets/imgs/orange-bg.webp', import.meta.url).href,
        oopsImage: new URL('@/assets/imgs/orange-oops.webp', import.meta.url).href,
      });

      // 与全局中间件逻辑一致：result = true 表示点击取消按钮（继续游戏)
      // result = false 表示点击确认按钮（离开游戏）
      // 这里的逻辑是：isConfirmLeave = !result
      const isConfirmLeave = !result;

      if (isConfirmLeave == false) { // 用户决定不走，要留下
        niuniuAskSum = 0; // 询问次数归零
        niuniuPendingNavigation = null; // 清空保存的目标路径
        return next(false); // 终止页面跳转，留在当前游戏
      } else {
        niuniuAskSum = 0; // 询问次数归零

        // 关键修复：先清理游戏状态和退出房间
        try {
          await cleanupRoomResources(false);
          // 设置退出标志，避免 onBeforeUnmount 重复清理
          isRoomExited.value = true;
        } catch (error) {
          console.error('[路由守卫] 资源清理失败:', error);
        }

        // 重置游戏运行状态
        joinStateStore.gameRunning = false;

        // 使用保存的第一次目标路径进行跳转
        const targetPath = niuniuPendingNavigation;
        niuniuPendingNavigation = null; // 清空保存的目标路径

        if (targetPath) {
          return next(targetPath);
        } else {
          return next();
        }
      }
    } finally {
      // 🔓 恢复浏览器返回事件监听
      window.onpopstate = originalPopstateHandler;
      console.log('[路由守卫] 已恢复浏览器返回事件');
    }
  } else {
    // 游戏未进行，直接允许离开
    console.log('[路由守卫] 游戏未进行，直接允许离开');
    return next();
  }
});

onBeforeUnmount(async () => {
  // 如果已经设置了退出标志，说明已经清理过了，直接移除事件监听即可
  if (!isRoomExited.value) {
    // 调用公共清理函数，不重新加入房间
    await cleanupRoomResources(false);
  }

  window.removeEventListener("resize", onResize)
  // 移除浏览器事件监听
  document.removeEventListener('visibilitychange', handleVisibilityChange);
})

</script>

<style lang="scss" scoped>
/* 淡入淡出过渡动画 - 解决 playStatus 弹窗抖动问题 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 通吃通赔显示容器 */
.result-display-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 889;
  pointer-events: none;

  /* 性能优化：启用硬件加速和GPU渲染 */
  will-change: transform, opacity;
  transform: translate3d(-50%, -50%, 0);
  /* 强制GPU加速 */
  backface-visibility: hidden;
  /* 减少渲染开销 */
  -webkit-font-smoothing: antialiased;
  /* 优化字体渲染 */
}

/* 结果容器 */
.result-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 背景雾图 */
.bg-fog {
  width: auto;
  height: 100px;
  position: relative;
  z-index: 1;
}

/* 结果图片 */
.result-image {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: none;
  z-index: 2;
}

/* 通吃通赔放大弹跳动画 - 增强提示感 */
.take-lose-all-enter-active {
  animation:
    take-lose-all-bounce 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55),
    take-lose-all-glow 1.5s ease-in-out 0.8s infinite;
}

.take-lose-all-leave-active {
  animation: take-lose-all-fade-out 0.4s ease-out;
}

@keyframes take-lose-all-bounce {
  0% {
    transform: translate(-50%, -50%) scale(0) rotate(-10deg);
    opacity: 0;
  }

  30% {
    transform: translate(-50%, -50%) scale(1.3) rotate(3deg);
    opacity: 1;
  }

  50% {
    transform: translate(-50%, -50%) scale(0.9) rotate(-2deg);
  }

  70% {
    transform: translate(-50%, -50%) scale(1.15) rotate(1deg);
  }

  85% {
    transform: translate(-50%, -50%) scale(0.98) rotate(0deg);
  }

  100% {
    transform: translate(-50%, -50%) scale(1) rotate(0deg);
    opacity: 1;
  }
}

@keyframes take-lose-all-glow {

  0%,
  100% {
    transform: translate(-50%, -50%) scale(1);
    filter: brightness(1) drop-shadow(0 0 10px rgba(255, 255, 255, 0.3));
  }

  50% {
    transform: translate(-50%, -50%) scale(1.05);
    filter: brightness(1.2) drop-shadow(0 0 20px rgba(255, 255, 255, 0.6));
  }
}

@keyframes take-lose-all-fade-out {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }

  100% {
    transform: translate(-50%, -50%) scale(0.5);
    opacity: 0;
  }
}

/* 通赔红色发光效果 */
.result-image-red {
  animation: result-red-pulse 1s ease-in-out infinite;
}

@keyframes result-red-pulse {

  0%,
  100% {
    filter: drop-shadow(0 0 8px rgba(255, 50, 50, 0.6));
  }

  50% {
    filter: drop-shadow(0 0 15px rgba(255, 50, 50, 0.9)) drop-shadow(0 0 25px rgba(255, 0, 0, 0.5));
  }
}

/* 通吃绿色发光效果 */
.result-image-green {
  animation: result-green-pulse 1s ease-in-out infinite;
}

@keyframes result-green-pulse {

  0%,
  100% {
    filter: drop-shadow(0 0 8px rgba(50, 255, 50, 0.6));
  }

  50% {
    filter: drop-shadow(0 0 15px rgba(50, 255, 50, 0.9)) drop-shadow(0 0 25px rgba(0, 255, 0, 0.5));
  }
}

/* 提示框过渡动画 - 缓慢显示和关闭 */
.slide-fade-enter-active {
  transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.slide-fade-leave-active {
  transition: all 0.4s cubic-bezier(0.55, 0.085, 0.68, 0.53);
}

.slide-fade-enter-from {
  opacity: 0;
}

.slide-fade-enter-from .show-result-tip {
  transform: translateY(-30px);
  opacity: 0;
}

.slide-fade-leave-to {
  opacity: 0;
}

.slide-fade-leave-to .show-result-tip {
  transform: translateY(-30px);
  opacity: 0;
}

/* 开奖阶段进入房间提示窗口 */
.show-result-tip-container {
  max-width: 500px;
  margin: 0 auto;
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 890;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}

.show-result-tip {
  width: inherit;
  height: 58px;
  margin: 0px 16px;
  border-radius: 8px;
  padding: 0px 16px;
  background: #0D131CCC;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border: 1px solid var(--betCorgi-color-red_erro, #ED1D49);
  box-shadow: 0px 0px 15px 0px #0000004D;
  backdrop-filter: blur(5px);
  margin-top: var(--header-heigh);
  pointer-events: auto;
  transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);

  .tip-icon {
    color: var(--betCorgi-color-red_erro, #ED1D49);
    stroke: black;
    flex-shrink: 0;
  }

  .close-icon {
    color: #55657E;
    cursor: pointer;
    flex-shrink: 0;
  }

  .tip-text {
    flex: 1;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #FFFFFF;
  }
}

.indoor-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(135deg, #0f4c3a 0%, #1a5f4a 100%);
  overflow: hidden;
}

/* 消息提示样式 */
.message-toast {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px 24px;
  border-radius: 8px;
  color: white;
  font-weight: 500;
  z-index: 9999;
  animation: slideDown 0.3s ease-out;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.message-success {
  background: linear-gradient(135deg, #4CAF50, #45a049);
}

.message-error {
  background: linear-gradient(135deg, #f44336, #d32f2f);
}

.message-warning {
  background: linear-gradient(135deg, #ff9800, #f57c00);
}

.message-info {
  background: linear-gradient(135deg, #2196F3, #1976D2);
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

/* 下注记录面板样式 */
.betting-records {
  position: fixed;
  top: 80px;
  right: 20px;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 12px;
  padding: 16px;
  min-width: 200px;
  max-width: 300px;
  z-index: 1000;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.betting-records h3 {
  color: #FFD700;
  font-size: 14px;
  margin: 0 0 12px 0;
  text-align: center;
  font-weight: 600;
}

.bet-list {
  max-height: 200px;
  overflow-y: auto;
  margin-bottom: 12px;
}

.bet-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.bet-item:last-child {
  border-bottom: none;
}

.bet-area {
  color: #FFD700;
  font-weight: 500;
  font-size: 12px;
}

.bet-value {
  color: #4CAF50;
  font-weight: 600;
  font-size: 12px;
}

.remove-btn {
  background: linear-gradient(135deg, #f44336, #d32f2f);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.remove-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(244, 67, 54, 0.3);
}

.bet-summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.bet-summary span {
  color: #FFD700;
  font-weight: 600;
  font-size: 12px;
}

.clear-all-btn {
  background: linear-gradient(135deg, #ff9800, #f57c00);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;
}

.clear-all-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.3);
}

.game-container {
  position: relative;
  max-width: 500px;
  margin: 0 auto;
  max-height: calc(100vh - var(--header-heigh));
  height: calc(100vh - var(--header-heigh));
  background-image: url(../img/indoor/bg.webp);
  background-size: cover;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}


.game-main {
  flex: 1;
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
}
/* 筹码选择器展开时，区域上移 */
.game-main--expanded {
  margin-top: -5.188rem;
  transition: margin-top 0.3s ease;
}
/* 固定定位的设置按钮 */
.settings-wrapper {
  padding: 8px 12px;
  background: linear-gradient(180deg, rgba(0,0,0,0.3) 0%, transparent 100%);
}

:deep(.footer) {
  position: relative;
  z-index: 66;
}

/* 筹码价值显示区域 */
.chip-value-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
  padding-top: 14px;
}

.chip-container{
  box-shadow: 0 -0.125rem 0.625rem rgba(0, 0, 0, 0.2);
}

.cancel-btn {
  display: flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 10px;
  border: 1px solid rgba(147, 172, 211, 0.18);
  background: rgba(9, 12, 17, 0.60);
  span {
    color: #A7B5CA;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    margin-left: 2px;
  }
}

.chip-value-label {
  font-size: 12px;
  color: var(--color_grey-40);
  font-weight: 500;
  line-height: 16px;
}

.chip-value-display {
  display: flex;
  align-items: center;
  gap: 4px;
}

.chip-value-amount {
  font-size: 12px;
  color: var(--color_grey-40);
  font-weight: 700;
  line-height: 12px;
}

/* 筹码控制面板 */
.chip-control-panel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

/* 筹码折叠面板包装器 */
.chip-expansion-wrapper {
  background: rgba(9, 12, 17, 0.6);
  border-radius: 10px;
  border: 1px solid rgba(147, 172, 211, 0.18);
  flex: 1;
  min-width: 0;
  /* 允许flex收缩 */
  padding: 12px 0px 12px 14px;
  box-sizing: border-box;
  /* 确保padding不增加总宽度 */
  overflow: hidden;
  /* 防止内容溢出 */
}

.chip-expansion-wrapper :deep(.q-item) {
  padding: 0px;
}

.chip-expansion-wrapper :deep(.q-item__section--avatar) {
  min-width: auto;
  padding-right: 8px;
}

/* 折叠图标渐变色和旋转动画 */
.chip-expansion-wrapper :deep(.q-icon) {
  background: linear-gradient(180deg, #1398F9 -14.24%, #0C5EFF 126.1%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 20px;
  transition: transform 0.3s ease;
  transform: rotate(0deg);
  transform-origin: center center;
  display: inline-block;
  /* 确保图标大小和旋转效果 */
}

/* 图标区域样式 */
.chip-expansion-wrapper :deep(.q-item__section--side) {
  padding-right: 8px;
  padding-left: 10px;
  display: flex;
  align-items: center;
  min-width: 24px;
  /* 确保有足够的宽度 */
}

/* 展开状态时图标旋转180度 */
:deep(.chip-expansion-wrapper.q-expansion-item--expanded .q-icon) {
  transform: rotate(180deg);
}

/* 移除hover背景色 */
:deep(.q-expansion-item__container) {
  .q-hoverable:hover>.q-focus-helper {
    background: none;
    opacity: 0;
  }
}

/* 折叠头部内容 */
.chip-expansion-header-content {
  display: flex;
  align-items: center;
  width: 100%;
}

/* 头部筹码选择器（前5个） */
.chip-selector-header {
  display: flex;
  align-items: center;
  /* gap: 0.5rem; 低版本浏览器不兼容，改用margin */
  margin-right: -0.5rem;
  /* 抵消最后一个元素的margin */
  flex: 1;
  /* 占据剩余空间 */
  min-width: 0;
  /* 允许flex收缩 */
  overflow: hidden;
  /* 防止内容溢出 */
}

.chip-selector-header>.chip-item {
  flex: 0 0 2rem;
  /* 固定宽度 */
  width: 2rem;
  /* 明确宽度 */
  height: 2rem;
  /* 明确高度，保持正方形 */
  margin-right: 0.5rem;
  /* 替代gap，所有元素右侧间距 */
}

/* 展开区域筹码选择器（后4个） */
.chip-selector-expanded {
  display: flex;
  align-items: center;
  /* gap: 0.5rem; 低版本浏览器不兼容，改用margin */
  margin-right: -0.5rem;
  /* 抵消最后一个元素的margin */
  width: 100%;
  margin-top: 0.75rem;
  overflow: hidden;
  /* 防止内容溢出 */
}

.chip-selector-expanded>.chip-item {
  flex: 0 0 2rem;
  /* 固定宽度 */
  width: 2rem;
  /* 明确宽度 */
  height: 2rem;
  /* 明确高度，保持正方形 */
  margin-right: 0.5rem;
  /* 替代gap，所有元素右侧间距 */
}

/* 筹码项目 */
.chip-item {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 0.125rem solid transparent;
  border-radius: 50%;
  box-sizing: border-box;
  transition: all 0.3s ease-in-out;
  padding: 0.125rem;
  flex-shrink: 0;
}

/* 筹码 PNG 图片样式 */
.chip-png {
  width: 100%;
  height: 100%;
  object-fit: contain;
  pointer-events: none;
}

.chip-active {
  border-color: #2283F6 !important;
  animation: borderGlow 1.5s ease-in-out infinite;

  svg,
  .chip-png {
    filter: drop-shadow(0 0 0.25rem rgba(34, 131, 246, 0.3));
  }
}

.repeat-btn {
  width: 4.813rem;
  align-self: stretch;
  /* 强制拉伸以匹配外层高度 */
  display: flex;
  flex-direction: column;

  :deep(.button-3d__outer) {
    display: flex;
    flex-direction: column;
    // width: 5rem;
    flex: 1;
  }

  :deep(.button-3d__inner) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 5rem;
    flex: 1;
  }
}

/* 边框发光动画 */
@keyframes borderGlow {

  0%,
  100% {
    border-color: #2283F6 !important;
    box-shadow: 0 0 0 rgba(34, 131, 246, 0);
  }

  50% {
    border-color: #4A9EFF !important;
    box-shadow: 0 0 0.75rem rgba(34, 131, 246, 0.6);
  }
}

/* 飞行筹码样式 */
.flying-chip {
  transition: none !important;
  box-shadow: 0 0.25rem 1.25rem rgba(0, 0, 0, 0.3);
  filter: drop-shadow(0 0 0.5rem rgba(34, 131, 246, 0.5));
}

/* 永久筹码样式（简化版） */
.permanent-chip {
  width: 0.938rem;
  height: 0.938rem;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 3;
  /* 用户自己下注的筹码层级，低于统计浮层(5) */
}

.permanent-chip:hover {
  transform: scale(1.1);
  filter: drop-shadow(0 0 0.375rem rgba(255, 215, 0, 0.6));
}

/* 筹码数量标签样式 */
.chip-count-label {
  position: absolute;
  top: -0.5rem;
  right: -0.5rem;
  background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);
  color: #000;
  font-size: 0.5rem;
  font-weight: bold;
  padding: 0.063rem 0.188rem;
  border-radius: 0.375rem;
  min-width: 0.75rem;
  text-align: center;
  z-index: 15;
  /* 略高于筹码本身，确保数量标签显示在筹码上方 */
  display: none;
  transition: all 0.2s ease;
  box-shadow: 0 0.063rem 0.188rem rgba(0, 0, 0, 0.3);
  border: 0.063rem solid rgba(255, 255, 255, 0.3);
}

/* 其他玩家筹码容器样式 */
.other-player-chip-container {
  position: relative;
}

/* 其他玩家的永久筹码 */
.other-player-permanent-chip {
  z-index: 3;
  /* 其他玩家下注的筹码层级，低于统计浮层(5) */
}

.other-player-chip-container:hover .other-player-permanent-chip {
  transform: scale(1.1);
  filter: drop-shadow(0 0 0.375rem rgba(34, 131, 246, 0.6));
}

/* 玩家标识气泡样式 */
.player-bubble {
  position: absolute;
  top: -0.375rem;
  right: -0.375rem;
  width: 0.75rem;
  height: 0.75rem;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.375rem;
  z-index: 10;
  border: 0.063rem solid rgba(0, 0, 0, 0.2);
  box-shadow: 0 0.063rem 0.125rem rgba(0, 0, 0, 0.2);
}

/* 下注区域样式增强 */
.betting-area {
  position: relative;
  min-height: 1.875rem;
  border-radius: 0.5rem;
  transition: all 0.2s ease;
}

.betting-area:hover {
  background: rgba(255, 255, 255, 0.05);
}

/* 筹码选择器增强 */
.chip-item {
  position: relative;
  overflow: visible;
}

.chip-item::after {
  content: '';
  position: absolute;
  top: -0.125rem;
  left: -0.125rem;
  right: -0.125rem;
  bottom: -0.125rem;
  border-radius: 50%;
  background: transparent;
  transition: all 0.3s ease;
  pointer-events: none;
}

.chip-active::after {
  background: radial-gradient(circle, rgba(34, 131, 246, 0.2) 0%, transparent 70%);
  animation: chipPulse 2s ease-in-out infinite;
}

@keyframes chipPulse {

  0%,
  100% {
    transform: scale(1);
    opacity: 0.6;
  }

  50% {
    transform: scale(1.1);
    opacity: 1;
  }
}

/* 倒计时样式 */
.betting-countdown {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}

.countdown-wrapper {
  background: rgba(0, 0, 0, 0.8);
  border: 0.125rem solid gold;
  border-radius: 0.625rem;
  padding: 0.938rem 1.875rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 0 1.25rem rgba(255, 215, 0, 0.5);
}

.countdown-text {
  color: white;
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 0.625rem;
  text-shadow: 0 0 0.313rem gold;
}

.countdown-number {
  color: gold;
  font-size: 3.75rem;
  font-weight: bold;
  line-height: 1;
  text-shadow: 0 0 0.625rem rgba(255, 215, 0, 0.8);
}
</style>